import { DatePipe } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from "lodash";
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService, } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { FormCanDeactivate, PatientService, UserService } from '../../shared';
import { User } from '../../shared/models';


@Component({
  selector: 'app-patientdetails',
  templateUrl: './patientdetails.component.html',
  styleUrls: ['./patientdetails.component.css']
})
export class PatientdetailsComponent extends FormCanDeactivate {
  alertShowed: boolean;
  @ViewChild('ed')
  form: NgForm;
  @ViewChild('pr')
  pr: NgForm;
  tempphone: any;
  tempphoneOther: any;
  surdis: boolean;
  i: number;
  hospitalList: any[];
  modalRef14: BsModalRef;
  modalRef13: BsModalRef;
  bodyside: any[] = [];
  temp: boolean;
  addpart: any[];
  enablemenu: any;
  disabled: boolean;
  tempbodypart: any;
  saveenabled: boolean = true;
  imgMaxSize: any = environment.imagefileSize;
  modalRef: BsModalRef;
  modalRefcanSch: BsModalRef;
  public imageURL: string = environment.cloudeImageURL;
  Backdrop: true;

  resabs: string;

  title: any = '';
  resp: string;
  respass: string;
  oneAtATime: boolean = true;
  enableshow: boolean = false;
  enable: boolean = true;
  public temp_var: boolean = false;
  public message: any;
  modaldata: any;
  apiurl: any = environment.api_url;
  public timealert = environment.timelimit;
  surveyform: any;
  public params: any;
  actbody: any;
  public data: Object;

  documenturl: string = environment.documenturl;
  public carepath: any = {};
  public patapp;
  public biograph: any;
  public carefamily: any;
  public patsum: any = {};
  public Status: any;
  public datapost: any = {};
  public dataed: any = {};
  public documentsdata: any = [];
  public docedit: any = {
    DocDesc: '',
    DocTitle: ''
  };
  public pad: any = {

  };
  patap: any;
  mcare: any;
  pcare: any;
  plist: any = [];
  public patname: any;
  patid: any;
  patcare: any;
  getact: any;
  currentUser: User
  user: any;
  getapp: any;
  open: any
  episodeid: any
  patfamily: any;
  public checkDos: any;
  public patientAppoinmentList = [];
  activityboard: any
  dtOptions: any = {};
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropperReady = false;
  public today = new Date();
  public mintimeset = 0;
  setImage: boolean = false;

  menu: any;
  excludeBundle: boolean;
  menustatus: any = {
    message: false,
    appoinment: false,
    document: false
  };
  bodypartCopy: any = [];
  bodylocation: any = [];
  public bodypart: any = {
    anybodypart: this.bodypartCopy.patServiceLineLabel
  };

  bodyloc: any = [];

  bodyl: any;
  frac: boolean;
  locat: any;
  changetype: any;
  @ViewChild('staticTabs', {}) staticTabs: TabsetComponent;
  tempCode: any;
  selectTab(tabId: number) {
    this.staticTabs.tabs[tabId].active = true;
  }
  // ---- end ----
  setmask: any;
  setmask1: any;
  maxlen: any;
  maxlen1: any;
  setlength: any;
  setlength1: any;
  bodysurgical: any[];
  payortypechange: any;
  patientbundle: any;
  facility: any[];
  required1: boolean = false;
  // frac: boolean;
  bodysideempty: boolean = false;
  public pay: any = {}
  locatbody: any;
  dosStatus: boolean;
  dateform: any = environment.dateForm
  // carepath: any;
  surgeonList: any;
  // bodyside: any[];
  // temp: boolean;
  // addpart: any[];
  index: number;
  // tempbodypart: any;
  // bodyl: any;
  // locat: any;
  public hiddenchecked: boolean = false;
  public showcross: boolean = false;
  shospital2: boolean;
  bodyparttype: boolean;
  // bodyloc: any;
  // bodypartCopy: any;
  // user: any;
  // hospitalList: any[];
  show: any;
  showph: any;
  payortype: any;
  maxdate: boolean;
  mindate: boolean;
  showinvaild1: boolean;
  shospital1: boolean;
  shospital3: boolean;
  shospital4: boolean;
  shospital5: boolean;
  public makeAllDisable: boolean = false;
  // imgMaxSize: any;
  public patientdetail: any = {
    ssn: '',
    mrnNo: '',
    bpci: 'No',
    PatientSWfId: '',
    code: '+1,USA',
    codeOther: '+1,USA',
    otherPhoneType: 1

  }
  // currentUser: User;
  uid: any
  // modalRef: BsModalRef;
  modalRef1: BsModalRef;
  // resp: string;
  // respass: string;
  clienttype: string;
  public temMail: any;
  imagearr: { filename: any; filetype: any; value: any; }[];
  // public temp_var: boolean = false;
  public showinvaild: boolean = false;
  // public message: any;
  public codes: any = [];
  public alterNo = [];
  showloader: boolean = false;
  dataimg: any;
  public patientinfo: any = {};
  public bobMaxDate = new Date();
  // public params: any;
  public hospitalid: any;
  public patientStatus: any;
  myInputVariable: any;
  public datenew = new Date("01/01/1800");
  public patientUrl = './assets/img/users/addusericon.png'
  public defaultUl = './assets/img/users/addusericon.png'
  // apiurl: any = environment.api_url;
  // public timealert = environment.timelimit;
  // dtOptions: any = {};
  status: boolean = false;
  emailcheck: boolean = false;
  mobile: boolean = false;
  public dateformat = environment.dateFormat;
  public bsConfig: any;
  required: boolean = false;
  emailstatus: boolean;
  invited: boolean = false;
  edinvited: any;
  openpopup: boolean = false;
  patemail: boolean = false;
  patphone: boolean = false;
  patphoneOther: boolean = false;
  validatemail: boolean = false;
  // public imageURL:string;
  defaultcode: string;
  cn: string
  activestatus: boolean = false;
  selectedUserId: any;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
    this.movable()
  }
  constructor(
    private patientservice: PatientService,
    private userService: UserService,
    private router: ActivatedRoute,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    private toast: ToastrService,
    private nav: Router,
    private localeService: BsLocaleService
  ) {
    super();
    if (window.localStorage['patDetails']) {
      this.params = JSON.parse(atob(window.localStorage['patDetails']))
    }
    enGbLocale.invalidDate = '';
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');
  }
  //--start pats---

  log(event: boolean, i) {
    this.activityboard[i].open = event;

    //////console.log(this.activityboard[i].open);
  };
  /*video(template: TemplateRef<any>,video) {
    this.modalRef = this.modalService.show(template);
    this.actbody = video;
  }  */
  openedit(template: TemplateRef<any>, bodypart: any) {

    this.modalRef = this.modalService.show(template, {
      backdrop: 'static'
    });
    this.bodypart = Object.assign({}, bodypart);
    this.bodypartCopy = bodypart
    ////console.log("bodypart", bodypart.Fracture)
    ////console.log("bodypart", this.bodypartCopy)
    ////console.log("bodypart1", this.bodypartCopy.patServiceLineLabel)
    if (bodypart.Fracture == "Y") {
      this.frac = true;
    }
    else {
      this.frac = false;
    }
    ////console.log("frac", this.frac)
  }


  openedithos(template2: TemplateRef<any>, hospital: any) {
    this.showhoslist(template2, hospital);
    this.bodyl = hospital


  }
  showhoslist(template2, hosp) {
    let self = this;
    self.patientservice.getHospitalList(self.currentUser.item.userAccountId)
      .subscribe(data => {
        this.hospitalList = _.filter(data.aaData, (o) => {
          return o.hospitalId != 10001
        })
      })
    this.modalRef14 = this.modalService.show(template2, {
      backdrop: 'static'
    });
  }

  close1() {
    this.modalRef13.hide();
    this.saveenabled = true
  }
  close2() {
    this.modalRef14.hide();
    this.saveenabled = true
  }

  update(template: TemplateRef<any>) {
    this.getAppoinmentsList(this.patid.patientSWFId)
    this.modalRef = this.modalService.show(template, { class: 'modal-lg', backdrop: 'static' });
    this.movable()
  }

  document(template: TemplateRef<any>) {
    this.resabs = " ";
    this.croppedImage = '';
    this.modalRef = this.modalService.show(template, {
      backdrop: 'static'
    });
  }
  editdocumentss(template: TemplateRef<any>, doc: any) {
    //debugger
    this.resabs = " ";
    //this.setImage = true;
    this.docedit = Object.assign({}, doc);
    this.croppedImage = environment.api_url + this.docedit.DocPath;
    //this.fileChangedEventedit(event);
    //	this.imageChangedEvent = this.croppedImage;
    // //////console.log(this.docedit);
    this.modalRef = this.modalService.show(template, {
      backdrop: 'static'
    });

  }
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;

    let acceptFormat = ['image/png', 'image/x-png', 'image/jpeg', 'image/jpg']
    //console.log(this.imageChangedEvent.srcElement);
    if (!acceptFormat.includes(this.imageChangedEvent.srcElement.files[0].type)) {
      this.toast.error(this.userService.translateText('hospital_portal.disp_messages.file_not_allowed.error'), '', {
        timeOut: this.timealert
      })
      this.imageChangedEvent = "";
      // this.croppedImage = this.defaultUl;
      return;
    } else if (this.imageChangedEvent.srcElement.files[0].size > this.imgMaxSize) {
      this.toast.error(this.userService.translateText('patient_portal.validations.maximum_size_exceed.error_label'), '', {
        timeOut: this.timealert
      })
      this.imageChangedEvent = "";
      // this.croppedImage = this.defaultUl;
      return;
    }

    // //console.log(this.imageChangedEvent.srcElement.files[0].name);
  }


  imageCropped(image: string) {
    this.croppedImage = image;

    // //console.log(this.croppedImage);
  }
  imageLoaded() {


    this.cropperReady = true;
  }
  imageLoadFailed() {
    //console.log('Load failed');
  }


  phonevalue: boolean = false;
  phonevalueOther: boolean = false;
  phoneOthervalue: boolean = false;
  placeholder = {
    weight: 'lbs',
    height: 'ft',
    inches: 'in'
  }
  //----end pats----
  openConfirm(confirm: TemplateRef<any>, ed) {
    this.modalRef1 = this.modalService.show(confirm, { class: 'modal-md', backdrop: 'static' });
    this.movable()
    this.edinvited = ed
    this.openpopup = true
  }
  ngOnDestroy() {
    if (this.ModelRef41)
      this.ModelRef41.hide()
    if (this.modalRef)
      this.modalRef.hide()
    if (this.modalRef1)
      this.modalRef1.hide()
    if (this.modalRef13)
      this.modalRef13.hide()
    if (this.modalRef14)
      this.modalRef14.hide()
    if (this.changeModalref)
      this.changeModalref.hide()
    if (this.modalRefcanSch)
      this.modalRefcanSch.hide()
  }

  ngOnInit() {
    this.phoneOthervalue = false
    this.phonevalueOther = false;
    this.reass = false
    this.checkFormDisable = false;

    this.bindEditLoad();
    this.getAppoinments()
    this.getPatientDetailspat()
    //this.getScanDocuments();
    this.getmenu();
    this.getAssement();
    //---end pats---
  }

  bindEditLoad() {
    this.userService.currentUser.subscribe(
      (userData) => {

        this.currentUser = userData;
        if (this.currentUser.item) {
          this.selectedUserId = window.localStorage['superClientId'] ? window.localStorage['superClientId'] : this.currentUser.item.userAccountId;
          this.setmask = this.currentUser.item.phoneFormat.split('#').join('0').concat('0');
          this.setmask1 = this.currentUser.item.phoneFormat.split('#').join('0').concat('0');
          if (this.currentUser.item.language != 'en_uk') {
            this.patientdetail.code = '+1,USA'
            this.patientdetail.codeOther = '+1,USA'
            this.defaultcode = this.patientdetail.code
            if (this.currentUser.item.clientTeleCode) {
              this.patientdetail.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
              this.patientdetail.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
              this.defaultcode = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
            }
          } else if (this.currentUser.item.language == 'en_uk') {
            this.patientdetail.code = '+44,UK'
            this.patientdetail.codeOther = '+44,UK'
            this.defaultcode = this.patientdetail.code
            if (this.currentUser.item.clientTeleCode) {
              this.patientdetail.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
              this.patientdetail.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
              this.defaultcode = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
            }
            this.placeholder.weight = 'kg'
            this.placeholder.height = 'm'
            this.placeholder.inches = 'cm'
          }

          if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
            this.dateform = environment.dateForm
          } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
            this.dateform = 'dd/MM/yyyy'
          }
          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat, customTodayClass: 'custom-today-class' });
          if (this.currentUser.item.userrole == 'Care Navigator' || this.currentUser.item.userrole == 'Care Coordinator' || this.currentUser.item.userrole == 'Hospital Care Navigator' || this.currentUser.item.userrole == 'Commercial Care Navigator' || this.currentUser.item.userrole == 'Surgeon' || this.currentUser.item.userGroupId == 32 || this.currentUser.item.userGroupId == 33) {

            if (this.currentUser.item.userrole == 'Surgeon') {
              this.disabled = false
              this.surdis = true
              this.makeAllDisable = true
            } else if (this.params.patstatus == 'Deactivate') {
              this.disabled = true;
              this.surdis = false
              this.makeAllDisable = true;
            }
            else {
              this.disabled = false
              this.surdis = false
              this.makeAllDisable = false
            }

          }
          else if (this.currentUser.item.userrole == 'Patient Enroller' || this.currentUser.item.userGroupId == 31 || this.currentUser.item.userGroupId == 30) {
            this.disabled = false;
            this.surdis = false
            this.makeAllDisable = false;
          } else {

            this.disabled = true;
            this.surdis = false
            this.makeAllDisable = true;
          }
          if (this.currentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;
        }

      }
    );

    this.clienttype = this.currentUser.item.clientType;
    this.hospitalid = this.currentUser.item.userAccountKey;
    this.uid = this.currentUser.item.userAccountId;
    this.patientStatus = this.params.patstatus;
    this.patientservice
      .getuserdetails(this.params.patientSWFId, this.uid)
      .subscribe(data => {
        if (Array.isArray(data) && data.length) {
          let self = this
          self.cn = data[0].caseManager
          ////console.log("user", this.user)
          if (data[0].mako)
            self.patientdetail.mako = data[0].mako
          else if (data[0].Mako)
            self.patientdetail.Mako = data[0].Mako
          self.patientdetail.phoneOther = data[0].phoneOther
          // this.patientdetail.otherPhoneType = 1
          self.patientdetail.teleCodeOther = data[0].teleCodeOther
          self.patientdetail.teleCountryCodeOther = data[0].teleCountryCodeOther
          self.patientdetail.otherPhoneType = data[0].otherPhoneType ? data[0].otherPhoneType : 1;
          if (self.patientdetail.phoneOther) {
            self.patientdetail.codeOther = self.patientdetail.teleCodeOther + ',' + self.patientdetail.teleCountryCodeOther
            self.phoneOthervalue = true
            self.phonevalueOther = true
            let x = self.patientdetail.phoneOther.split("");
            let y = []
            let k = []
            let m = []
            if (self.currentUser.item.language != 'en_uk') {
              for (var i = 0; i < 3; i++) {
                y[i] = x[i]
              }
              for (var j = 3; j < 6; j++) {
                k[j] = x[j]
              }
              for (var l = 6; l < x.length; l++) {
                m[l] = x[l]
              }
              self.patientdetail.phoneOther = '(' + y.join('') + ') ' + k.join('') + '-' + m.join('')
            }
            else {
              for (var z = 0; i < 5; z++) {
                y[z] = x[z]
              }
              for (var d = 5; l < x.length; d++) {
                m[d] = x[d]
              }
              self.patientdetail.phoneOther = y.join('') + ' ' + m.join('')
            }
            self.tempphoneOther = self.patientdetail.phoneOther
          } else {
            self.phoneOthervalue = false
            if (self.currentUser.item.clientTeleCode) {
              self.patientdetail.codeOther = self.currentUser.item.clientTeleCode + ',' + self.currentUser.item.clientCountryCode
            }
          }
        }
      })
    this.loadCareList()
    this.patientservice.getpatientdetails(this.params.patientId).subscribe(
      data => {
        let self = this
        for (var i = 0; i < data.length; i++) {
          self.patientdetail = data[i];
          console.log("patientdetail", this.patientdetail)
          self.temMail = data[i].email;
          if (self.patientdetail.phone) {
            self.tempphone = self.patientdetail.phone;
            self.patientdetail.code = self.patientdetail.teleCode + ',' + self.patientdetail.teleCountryCode
            self.phonevalue = true
            let x = self.patientdetail.phone.split("");
            let y = []
            let k = []
            let m = []
            if (self.currentUser.item.language != 'en_uk') {
              for (var e = 0; e < 3; e++) {
                y[e] = x[e]
              }
              for (var r = 3; r < 6; r++) {
                k[r] = x[r]
              }
              for (var g = 6; g < x.length; g++) {
                m[g] = x[g]
              }
              self.patientdetail.phone = '(' + y.join('') + ') ' + k.join('') + '-' + m.join('')
            }
            else {
              for (var q = 0; q < 5; q++) {
                y[q] = x[q]
              }
              for (var s = 5; s < x.length; s++) {
                m[s] = x[s]
              }
              self.patientdetail.phone = y.join('') + ' ' + m.join('')
            }
            self.tempphone = self.patientdetail.phone
          }
          else {
            if (self.currentUser.item.language != 'en_uk') {
              self.patientdetail.code = '+1,USA'
              self.patientdetail.codeOther = '+1,USA'
            } else if (self.currentUser.item.language == 'en_uk') {
              self.patientdetail.code = '+44,UK'
              self.patientdetail.codeOther = '+44,UK'
            }
            if (self.currentUser.item.clientTeleCode) {
              self.patientdetail.code = self.currentUser.item.clientTeleCode + ',' + self.currentUser.item.clientCountryCode
              self.patientdetail.codeOther = self.currentUser.item.clientTeleCode + ',' + self.currentUser.item.clientCountryCode
            }
          }
          self.tempCode = self.patientdetail.code
          self.patientdetail.dob = new Date(self.patientdetail.dob)
          self.mindos = self.patientdetail.dob;

          //this.checkphonlength(this.patientdetail.code)
          //this.checkphonlength1(this.patientdetail.codeOther)
          // ////console.log("code", this.patientdetail.code);
        }
        if (self.patientdetail.email) {
          self.required = true
        }
        if (data[0].Imagepath.search("default_") == -1)
          self.dataimg = this.imageURL + data[0].Imagepath;
        else
          self.dataimg = this.defaultUl
        // ////console.log("email", self.patientdetail.email);
        self.getpayortypelist();
        self.getPatientDetails();

        this.patientservice.getpatientinfo(this.params.patientId, this.params.patientSWFId).subscribe(
          data => {
            let self = this
            self.patientinfo = data[0];
            self.patientbundle = data[0].bundlePatientId;

            if (self.patientinfo.mako == 'Yes') {
              self.patientdetail.mako = 'Yes'
            } else {
              self.patientdetail.mako = 'No'
            }
            if (self.patientinfo.cjr == 'Yes') {
              self.patientdetail.cjr = true
            } else {
              self.patientdetail.cjr = false
            }
            if (self.patientinfo.commercialPatient)
              self.getbundlepayortypeprocedure(data[0].PayorType)
            //   ////console.log(this.patientinfo)
            if (data[0].PayorType == 1) {

              data[0].PayorType = 'Commercial'
            }
            else if (data[0].PayorType == 2)
              data[0].PayorType = 'Medicare'
            else if (data[0].PayorType == 3)
              data[0].PayorType = 'Medicare Advantage'
            else if (data[0].PayorType == 4)
              data[0].PayorType = 'Medicaid'
            else if (data[0].PayorType == 5)
              data[0].PayorType = 'Other'
            self.payortype = data[0].payorTypeName
            if (data[0].PayorType != 'Commercial' || !self.currentUser.item.commercialType) {
              self.bodysurgical = []
              self.patientservice.getSurgicalLocation(self.currentUser.item.userAccountKey, 0).subscribe(data => {
                self.bodysurgical = data
              })
            } else {
              self.patientservice.getuserid(self.params.patientId).subscribe(
                data => {
                  let self = this
                  self.payortype = data[0].PayorTypeName
                  self.payorId = data[0].payorId;
                  if (data[0].payorId != 4) {
                    self.fcn(data[0].payorId, self.user.surgeonId);
                    self.bodysurgical = []
                    self.patientservice.getSurgicalLocation(self.currentUser.item.userAccountKey, data[0].payorId).subscribe(data => {
                      self.bodysurgical = data
                    })
                  } else {
                    self.fcn1();
                    self.patientservice.getSurgicalLocation(self.currentUser.item.userAccountKey, 0).subscribe(data => {
                      self.bodysurgical = data
                    })
                  }
                }
              );
            }
            self.patientdetail.otherServicelineLabel = data[0].otherservicelabel;
            self.patientdetail.mako = data[0].mako
            ////console.log( this.patientinfo);
            setTimeout(() => {
              self.getcarepath()
            }, 1000);
            self.getBodyPart(self.locatbody);
            self.getSurgeonNames();
            self.getAllEventList()
            self.SetDosStatus(self.patientinfo.Dos)
          }
        );

      }
    );

    this.patientservice.getselcode(this.hospitalid)
      .subscribe(data => {
        this.codes = data;
      });

    this.patientservice.getAlterNo()
      .subscribe(data => {
        this.alterNo = data
        this.patientdetail.otherPhoneType = 1
      })
    this.getPlannedInterval()

    if (window.localStorage['patDetails']) {
      this.patid = JSON.parse(atob(window.localStorage['patDetails']))
    }
    this.patientservice
      .getPatsum(this.patid.patientId, this.patid.patientSWFId)
      .subscribe(
        data => {
          this.patsum = data;
        }
      );

    this.userService.getpcarefamily(this.patid.patientSWFId, this.patid.patientId)
      .subscribe(data => {
        this.mcare = data;
        //this.patcare = this.mcare.concat(this.pcare);
        this.patcare = this.mcare.HospitalCareNavigatorDetails.concat(this.mcare.CareNavigatorDetails);
        this.patcare = _.orderBy(this.patcare, ['sequenceNo'],
          ['asc']);
      }
      );


    this.patientservice
      .getcarelist(this.patid.patientId)
      .subscribe(data => {
        this.pcare = data;
        this.plist = data;
      }
      );

    // this.patientservice
    //   .getcarelist(this.patid.patientId)
    //   .subscribe(
    //     data => {
    //       this.plist = data;
    //       ////console.log(this.plist);
    //     }

    //   );
    this.patientservice
      .getbio(this.patid.patientId)
      .subscribe(data => {
        this.biograph = data.profileQuestions;
      }
      );

    this.patientservice
      .getpatapp(this.patid.patientId, this.patid.patientSWFId)
      .subscribe(data => {
        if (data)
          this.patapp = data;
        else
          this.patapp = null;
      }
      );
  }

  SetDosStatus(event) {

    if (event) {
      // event = this.changeFormatToDate(event)
      let self = this;
      let date = this.datepipe.transform(event, environment.dateForm);
      if (date) {
        let toDate = new Date();
        toDate.setDate(toDate.getDate() - 7);
        let Dos = new Date(date);
        if (toDate.getTime() < Dos.getTime()) {
          self.dosStatus = false

        }
        if (toDate.getTime() >= Dos.getTime()) {
          self.dosStatus = true
          //self.carePath.plannedDischargeId = ""
        }
      } else {
        self.dosStatus = false
      }

    }
    else {
      this.dosStatus = false
    }
    /* if(!self.actualCategory){
      self.enableactualTom(event)
    } */
  }
  getmenu() {
    //, this.currentUser.item.userAccountId
    this.userService
      .menuuserinfo(19, this.currentUser.item.userAccountId)
      .subscribe(data => {
        this.menu = data;

        ////console.log(this.menu);
        if (this.menu) {
          for (var i = 0; i < this.menu.length; i++) {
            if (this.menu[i].refName == "PAT_MESSAGES") {
              this.menustatus.message = this.menu[i].status;
            } else if (this.menu[i].refName == "PAT_APPOINTMENTS") {
              this.menustatus.appoinment = this.menu[i].status;
            } else if (this.menu[i].refName == "DOCUMENT_ALL") {
              this.menustatus.document = this.menu[i].status;
            }
          }

          ////console.log(this.menustatus);
        }
      });

    this.patientservice
      .getappvisible(this.patid.patientId, 11, this.currentUser.item.appRoles)
      .subscribe(data => {
        this.enablemenu = data[0].status;
      });
  }
  getSurgeonNames() {
    let self = this;
    this.patientdetail.surgeon = this.patientinfo.SurgeonName
    /* ////console.log("UseFilter",this.patientService.userFilter)

    this.userId = this.patientService.userFilter ?
          self.CurrentUser.item.userAccountId: this.patientService.userId; */

    self.patientservice.getSurgeonlist(self.currentUser.item.userAccountId)
      .subscribe(data => {
        this.surgeonList = data;
        // ////console.log("Surgeon List", self.surgeonList)
        let index = _.findIndex(self.surgeonList, (o: any): any => {
          return o.surgeonId == this.patientinfo.surgeonId
        })

        if (index != -1) {
          this.patientdetail.surgeon = self.surgeonList[index].surgeonId
          if (this.patientdetail.surgeon)
            self.user.surgeonId = this.patientdetail.surgeon
          this.changeSurgoen(self.user.surgeonId, false)
        }
      })
  }
  getcarepath() {
    this.patientservice
      .getcarepath(this.params.patientId, this.params.patientSWFId)
      .subscribe(
        data => {
          this.carepath = data;
          ////console.log(this.carepath, "CarePAth");
          if (this.carepath.Fracture == 'Y') {
            this.patientdetail.frac = true
          } else {
            this.patientdetail.frac = false
          }
        }
      );
  }

  getBodyPart(location) {
    let self = this;
    self.patientservice.getBodyLocation(this.currentUser.item.userAccountKey)
      .subscribe(data => {
        this.bodyloc = data
        if (location == this.locatbody) {
          this.patientdetail.procedure = this.patientinfo.serviceLineLabel
          this.patientdetail.procedureDisplayName = this.patientinfo.serviceLineLabelDisplayName
          this.patientdetail.laterality = this.patientinfo.serviceLineLaterality
          let index = _.findIndex(self.bodyloc.ServicelineLabel, (o: any): any => {
            return (o.ServicelineLabel == this.patientinfo.serviceLineLabel) && (o.SurgicalLocation == this.patientinfo.surgicallocation)
          })

          if (index != -1) {
            this.locat = self.bodyloc.ServicelineLabel[index].Location
            this.locatbody = self.bodyloc.ServicelineLabel[index].SurgicalLocation
            this.patientdetail.surgicallocationDisplayName = self.bodyloc.ServicelineLabel[index].SurgicalLocationDisplayName
          }
          this.patientdetail.location = this.locat
          this.patientdetail.surgical = this.locatbody
          if (!this.patientdetail.surgical) {
            this.patientdetail.surgical = this.patientinfo.surgicallocation
            this.patientdetail.surgicallocationDisplayName = this.patientinfo.surgicallocationDisplayName
          }
          this.bodyl = this.patientinfo.serviceLineLabel
          this.tempbodypart = this.bodyl
          // ////console.log(this.locat)
          // ////console.log(this.bodyl)
          this.showlist(this.patientinfo.serviceLineLabel, false);

        }
        else {
          this.patientdetail.procedure = ''
          this.patientdetail.laterality = ''
          let index = _.findIndex(self.bodyloc.ServicelineLabel, (o: any): any => {
            return (o.ServicelineLabel == this.patientinfo.serviceLineLabel) && (o.SurgicalLocation == this.patientinfo.surgicallocation)
          })

          if (index != -1) {
            this.locat = self.bodyloc.ServicelineLabel[index].Location
            this.locatbody = self.bodyloc.ServicelineLabel[index].SurgicalLocation
          }
          this.locat = location
          this.patientdetail.location = this.locat
          this.patientdetail.surgical = this.locatbody
          if (!this.patientdetail.surgical) {
            this.patientdetail.surgical = this.patientinfo.surgicallocation
          }
          this.bodyl = ''
          this.tempbodypart = this.bodyl
        }
      })
  }

  showprocedure(event) {
    this.patientdetail.surgical = this.patientdetail.surgicallocationDisplayName;
    this.patientdetail.procedure = ''
    this.patientdetail.laterality = ''
    // if (event == 'Upper Extremity') {
    //   this.patientdetail.mako = 'No'
    // }
  }

  showlist(bodypart, onchange) {
    let self = this;
    // this.patientdetail.procedure = this.bodyloc.ServicelineLabel.find(service => service.ServicelineLabelDisplayName == this.patientdetail.procedureDisplayName) ? this.bodyloc.ServicelineLabel.find(service => service.ServicelineLabelDisplayName == this.patientdetail.procedureDisplayName)['ServicelineLabel'] : ''
    if (environment.OpBodyPart.search(bodypart) == -1 && this.hospitalList && onchange) {

      let index = _.findIndex(self.hospitalList, (o: any): any => {
        return o.hospitalPracticeid == this.patientdetail.site
      })
      if (index != -1 && self.hospitalList[index].admissionId == 2) {
        this.patientdetail.site = ''
        this.shospital4 = true
      }
      this.hospitalList = _.filter(this.hospitalList, (o: any): any => {
        return o.admissionId != 2
      })
      //console.log(JSON.stringify(this.hospitalList))
    } else {
      self.patientservice.getHospitalList(self.currentUser.item.userAccountId)
        .subscribe(data => {
          this.hospitalList = _.filter(data.aaData, (o) => {
            return o.hospitalId != 10001
          })
          let index = _.findIndex(self.hospitalList, (o: any): any => {
            return o.hospitalId == this.user.hospitalId
          })

          if (index != -1) {
            self.user.hospitalPracticeid = self.hospitalList[index].hospitalPracticeid
            this.patientdetail.site = self.user.hospitalPracticeid
          } else {
            this.patientdetail.site = self.patientinfo.hospitalName
          }
          const selectElement = document.getElementById("sos") as any;
          const selectedValue = this.patientdetail.site;
          setTimeout(() => {
            for (let option of selectElement.options) {
              if (option.value == selectedValue) {
                option.selected = true;
              }
            }
          }, 250);
        })
    }
    if (this.locatbody)
      this.patientdetail.laterality = "";
    if (this.patientinfo.serviceLineLabel != bodypart)
      self.patientdetail.otherServicelineLabel = ''
    let index = self.bodyloc.ServicelineLabel.findIndex(o => (o.ServicelineLabel == bodypart) && (o.SurgicalLocationDisplayName == this.patientdetail.surgical));

    if (index != -1) {
      this.patientdetail.location = self.bodyloc.ServicelineLabel[index].Location
      this.patientdetail.surgical = self.bodyloc.ServicelineLabel[index].SurgicalLocation
    }
    if (this.patientinfo.serviceLineLabel != bodypart && (bodypart == 'Other' || bodypart == 'Other.')) {
      this.patientdetail.location = bodypart
      this.patientdetail.laterality = ''
    }
    if (this.patientinfo.surgicallocation != this.patientdetail.surgical && (bodypart == 'Other' || bodypart == 'Other.')) {
      this.patientdetail.otherServicelineLabel = ''
    }
    if (this.patientdetail.surgical == 'Neck' || this.patientdetail.surgical == 'Back') {
      this.patientdetail.laterality = this.patientdetail.surgical
    }

    if (bodypart == 'Partial Hip Replacement' || bodypart == 'Hip and Femur Fracture (SHFFT)') {
      this.patientdetail.frac = true
    } else {
      this.patientdetail.frac = false
      //this.getcarepath()
    }
    this.patientservice
      .getuserid(this.params.patientId)
      .subscribe(
        data => {
          this.temp_var = true;
          this.pay = data[0];
          // this.patientdetail.mako = data[0].Mako       // issue produced for multibody part fixed in v1.4
          this.payortype = data[0].PayorTypeName
          ////console.log(data[0])
          if (Array.isArray(data) && data.length) {
            this.addpart = data;

            if (bodypart != '') {
              this.temp = true

              let f2 = this.addpart[0].allServiceLineLabel.split(',')
              let temarray = _.filter(f2, (o: any): any => {
                return o.includes(bodypart)
              })
              if (temarray.length > 1 && bodypart != 'Other' && bodypart != 'Other.') {
                this.bodyside = [];
                this.patientdetail.laterality = this.patientinfo.serviceLineLaterality
                // this.bodysideempty= true
                return;
              }
              for (let i = 0; i < f2.length; i++) {
                let te;
                if (bodypart == 'Hip and Femur Fracture (SHFFT)' && f2[i].includes('Hip and Femur Fracture (SHFFT)')) {
                  f2[i] = f2[i].replace('(SHFFT)', "")
                }
                te = f2[i].split('(');
                te[1] = te[1].replace(')', "")
                te[1] = te[1].replace(/\s/g, "");
                te[0] = te[0].replace(/\s/g, "");
                f2[i] = te
                if (bodypart.replace(/\s/g, "") == te[0] || te[0] == 'HipandFemurFracture') {
                  if (te[1] == 'Left') {
                    if (bodypart.replace(/\s/g, "") != 'TotalShoulderReplacement' && !this.patientinfo.commercialPatient)
                      this.bodyside = ['Right', 'Bilateral']
                    else
                      this.bodyside = ['Right']
                    if (this.patientinfo.serviceLineLabel == bodypart && this.patientinfo.surgicallocation == this.patientdetail.surgical) {
                      this.patientdetail.laterality = this.patientinfo.serviceLineLaterality
                      //this.bodyside.push(this.patientinfo.serviceLineLaterality)
                    } else {
                      this.bodyside = ['Right']
                    }
                    return
                  }
                  else if (te[1] == 'Right') {
                    if (bodypart.replace(/\s/g, "") != 'TotalShoulderReplacement' && !this.patientinfo.commercialPatient)
                      this.bodyside = ['Left', 'Bilateral']
                    else
                      this.bodyside = ['Left']
                    if (this.patientinfo.serviceLineLabel == bodypart && this.patientinfo.surgicallocation == this.patientdetail.surgical) {
                      this.patientdetail.laterality = this.patientinfo.serviceLineLaterality
                      //this.bodyside.push(this.patientinfo.serviceLineLaterality)
                    } else {
                      this.bodyside = ['Left']
                    }
                    return
                  }
                  else if (te[1] == 'Bilateral') {
                    this.temp = false
                    if (this.patientinfo.serviceLineLabel == bodypart && this.patientinfo.surgicallocation == this.patientdetail.surgical) {
                      this.patientdetail.laterality = this.patientinfo.serviceLineLaterality
                      this.bodyside = ['Left', 'Right']
                      //this.bodyside.push(this.patientinfo.serviceLineLaterality)
                    } else {
                      this.bodyside = []
                    }
                    return
                  }
                }
              }

              if (this.payortype == 'Commercial' && this.currentUser.item.commercialType && this.patientinfo.commercialPatient) {
                if (bodypart == 'T-Spine') {
                  this.patientdetail.laterality = ''
                  return this.bodyside = []
                } else {
                  this.patientdetail.laterality = ''
                  return this.bodyside = ['Left', 'Right']
                }
              } else {
                if (this.patientdetail.location == 'Shoulder' || this.patientdetail.location == 'Sports' || this.patientdetail.location == 'Foot and Ankle' || this.patientdetail.location == 'Hand & Upper Extremities') {
                  this.patientdetail.laterality = ''
                  return this.bodyside = ['Left', 'Right']
                } else {
                  this.patientdetail.laterality = ''
                  return this.bodyside = ['Left', 'Right', 'Bilateral']
                }
              }






            }
            else {
              this.temp = false

            }
          }

        }
      );
  }

  payorId: any;
  fcn(payorId, surgeonId) {
    this.patientservice
      .getHospitalListbyPayor(payorId ? payorId : 4, this.currentUser.item.userAccountKey, surgeonId ? surgeonId : 0)
      .subscribe(
        data => {
          this.facility = data;
          // this.getvalid(this.facility)
        }

      );

  }
  fcn1() {
    this.patientservice.getHospitalList(this.currentUser.item.userAccountId)
      .subscribe(data => {
        this.facility = _.filter(data.aaData, (o) => {
          return o.hospitalId != 10001
        })
        let index = _.findIndex(this.facility, (o: any): any => {
          return o.hospitalId == this.user.hospitalId
        })

        if (index != -1) {
          this.user.hospitalPracticeid = this.facility[index].hospitalPracticeid
          this.patientdetail.site = this.user.hospitalPracticeid
        } else {
          this.patientdetail.site = this.patientinfo.hospitalName
        }

      })

  }
  public payortypelist: any;
  getpayortypelist() {
    let self = this;
    self.patientservice.getPayorTypeList(this.currentUser.item.userAccountKey)
      .subscribe(data => {
        this.payortypelist = data
      })
  }
  getPatientDetails() {
    let self = this;
    self.patientservice.getpatientinfo(self.params.patientId, self.params.patientSWFId)
      .subscribe(data => {

        if (Array.isArray(data) && data.length) {
          this.user = data[0];
          this.patientdetail.payor = this.user.PayorType
          if (self.user.commercialPatient && self.patientdetail.payorId != 4) {
            this.patientservice
              .getPatientFacility(this.patientbundle, this.currentUser.item.userAccountId)
              .subscribe(
                data => {
                  this.facility = data;
                  let index = _.findIndex(this.facility, (o: any): any => {
                    return o.name == this.user.hospitalName
                  })

                  if (index != -1) {
                    this.user.hospitalPracticeid = this.facility[index].hspPracticeId
                    this.patientdetail.site = this.user.hospitalPracticeid
                  } else {
                    this.patientdetail.site = this.patientinfo.hospitalName
                  }
                  // this.getvalid(this.facility)
                }

              );
          }
          else {

            self.patientservice.getHospitalList(self.currentUser.item.userAccountId)
              .subscribe(data => {
                this.hospitalList = _.filter(data.aaData, (o) => {
                  return o.hospitalId != 10001
                })
                let index = _.findIndex(self.hospitalList, (o: any): any => {
                  return o.hospitalId == this.user.hospitalId
                })

                if (index != -1) {
                  self.user.hospitalPracticeid = self.hospitalList[index].hospitalPracticeid
                  this.patientdetail.site = self.user.hospitalPracticeid
                } else {
                  this.patientdetail.site = self.patientinfo.hospitalName
                }
                if (environment.OpBodyPart.search(this.patientdetail.procedure) == -1) {
                  this.hospitalList = _.filter(this.hospitalList, (o: any): any => {
                    return o.admissionId != 2
                  })
                  //console.log(JSON.stringify(this.hospitalList))
                }
              })
          }
        }

      })
    /*  if(this.patientStatus =='Invited'){

       if( !this.patientdetail.email && !this.patientdetail.phone){
         this.invited = true
       }
       else{
         this.invited = false
       }
     } */
    /* if(this.patientStatus =='Invited'){

      if(this.patientdetail.email && this.patientdetail.phone){
        this.patemail = true
        this.patphone =true
      }
      else if(!this.patientdetail.email && this.patientdetail.phone){
        this.patemail = false
        this.patphone =true
        // ////console.log(this.patemail, this.patphone)
      }

      else if(this.patientdetail.email && !this.patientdetail.phone){
        this.patemail = true
        this.patphone =false
      }
    }
     */

  }


  checkempty1(id) {
    let date
    if (id != 'Invalid Date')
      date = this.datepipe.transform(id, 'yyyy-MM-dd');
    let curentdate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    if (id == '' || id == 'Invalid Date') {
      this.showinvaild1 = true;
      this.mindate = false;
      this.maxdate = false;
    } else if (id != '' && id != null && date <= "1800-01-01") {
      this.mindate = true;
      this.showinvaild1 = false;
      this.maxdate = false;
    } else if (id != '' && id != null && date > curentdate) {
      this.maxdate = true;
      this.showinvaild1 = false;
      this.mindate = false;
    } else {
      this.showinvaild1 = false;
      this.mindate = false;
      this.maxdate = false;
    }

  }


  checkPhoneClear: boolean;
  setPhoneValue: any;
  backupPhoneValue(event) {
    if (event) {
      this.checkPhoneClear = true;
      this.setPhoneValue = event;
    }
    else {
      this.checkPhoneClear = false;
    }

    // console.log("setPhoneValue",this.checkPhoneClear)
  }


  onSelection1(userdetails) {
    let self = this;
    //check phone number is already exists
    let code = this.patientdetail.code.split(',')
    if (self.patientdetail.phone && code[0] + this.tempphone != code[0] + this.patientdetail.phone) {
      let phone = code[0] + '-' + self.patientdetail.phone
      let tempcode = this.tempCode.split(',')
      let temPhone = ''
      if (this.tempphone) {
        temPhone = tempcode[0] + '-' + this.tempphone
      }
      let data = {
        "oldEmail": '',
        "newEmail": '',
        "oldPhone": temPhone,
        "newPhone": phone,
        "addOrEdit": 'edit',
        "updatingProfileRole": 19
      }
      self.patientservice.getUserExist(data, this.currentUser.item.userAccountKey)
        .subscribe(data => {
          if (data.status == 'success') {
            if (data.popUpStatus == 'true') {
              this.userService.getuserdetails(phone)
                .subscribe(
                  data => {
                    if (data.firstName) {
                      this.userinfo = data
                      if (((!this.patientdetail.firstName && !this.patientdetail.lastName && !this.patientdetail.email) || (data.firstName != this.patientdetail.firstName) || (data.lastName != this.patientdetail.lastName) || (data.email != this.patientdetail.email))) {

                        if (!this.modalRef1 || !this.modalRef1.content) {
                          this.modalRef1 = this.modalService.show(userdetails, {
                            class: 'modal-md',
                            backdrop: 'static'
                          })
                        }
                        //this.movable();
                        return false;
                      }
                    }
                  });
            }
            return true;
          } else {
            self.patientdetail.phone = "";

            if (!this.alertShowed) {
              this.toast.error(this.userService.translateText('patient_portal.validations.mobile_no_already_exist.error_label'), '', {
                timeOut: this.timealert
              })
              this.alertShowed = true;
            }
            setTimeout(() => {
              this.checkPhoneClear = false;
              this.setPhoneValue = "";
              // console.log(this.checkPhoneClear + '-' + this.setPhoneValue)
            }, 1000);

          }

        });

    }
    else {
      return true;
    }
  }

  calculateBmi() {
    let self = this;
    if (self.patientdetail.weight && self.patientdetail.height && String(self.patientdetail.inch)) {
      self.calculateBMI(self.patientdetail.weight, self.patientdetail.height, self.patientdetail.inch)
    } else {
      self.patientdetail.bmi = null;
    }
  }
  userinfo: any;
  checkEmailClear: boolean;
  setEmailValue: any;
  backupEmailValue(event) {
    this.emailChanged = true;
    if (event == '') {
      this.checkEmailClear = true;
      this.setEmailValue = event;
      this.validatemail = false
    }
    else {
      this.checkEmailClear = false;
      if (this.validateEmail(event))
        this.validatemail = false
      else
        this.validatemail = true
    }
  }

  checkemail(userdetails) {
    let self = this;
    if (self.temMail == self.patientdetail.email) {
      return true;
    }
    if (self.patientdetail.email) {
      let data = {
        "oldEmail": self.temMail,
        "newEmail": self.patientdetail.email,
        "oldPhone": '',
        "newPhone": '',
        "addOrEdit": 'edit',
        "updatingProfileRole": 19
      }
      self.patientservice.getUserExist(data, this.currentUser.item.userAccountKey).subscribe(data => {
        this.emailChanged = false;
        if (data.status == 'success') {
          if (data.popUpStatus == 'true') {
            self.emailcheck = true
            self.required = true
            this.userService.getuserdetails(self.patientdetail.email).subscribe(
              (data) => {
                if (data.firstName) {
                  this.userinfo = data
                  if (((!this.patientdetail.firstName && !this.patientdetail.lastName && !this.patientdetail.email) || ((data.firstName != this.patientdetail.firstName) || (data.lastName != this.patientdetail.lastName)))) {
                    if (!this.modalRef1 || !this.modalRef1.content)
                      this.modalRef1 = this.modalService.show(userdetails, {
                        class: 'modal-md',
                        backdrop: 'static'
                      })
                    // this.movable();
                  }
                }
              });
            return false;
          }
          else {
            return true;
          }
        }
        else {
          if (!this.alertShowed) {
            this.toast.error(this.userService.translateText('hospital_portal.disp_messages.email_already_exist.error'), '', {
              timeOut: 1000
            })
            this.alertShowed = true;
          }
          self.patientdetail.email = "";

          setTimeout(() => {
            this.checkEmailClear = false;
            this.setEmailValue = "";
            // console.log(this.checkEmailClear + '-' + this.setEmailValue)
          }, 1000);
          return false;
        }
      });
    }
    else {
      this.emailChanged = false;
      return true;
    }
  }

  calculateBMI(weight, height, inch) {
    let self = this;
    weight = parseFloat(weight);
    height = parseInt(height);
    inch = parseInt(inch);
    if (this.currentUser.item.language != 'en_uk') {
      weight = weight * 0.453592;
      height = (((height * 12) + inch) * .0254);
      let bmi = weight / Math.pow(height, 2.0);
      self.patientdetail.bmi = String(bmi) == ("Infinity" || "NAN") ? "" : bmi.toFixed(2)
    } else {
      height = ((height * 100) + inch);
      let bmi = (weight / height / height) * 10000
      self.patientdetail.bmi = String(bmi) == ("Infinity" || "NAN") ? "" : bmi.toFixed(2)
    }
  }



  fileUpload(event) {
    let acceptFormat = ['image/png', 'image/x-png', 'image/jpeg', 'image/jpg']
    let reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (events: any) => {
      if (!acceptFormat.includes(event.target.files[0].type)) {
        this.toast.error(this.userService.translateText('patient_portal.validations.file_not_allowed.error_label'), '', {
          timeOut: this.timealert
        })
        this.myInputVariable.nativeElement.value = "";
        this.dataimg = this.defaultUl;
        return;
      }
      if (event.target.files[0].size > this.imgMaxSize) {
        this.toast.error(this.userService.translateText('patient_portal.validations.maximum_size_exceed.error_label'), '', {
          timeOut: this.timealert
        })
        this.myInputVariable.nativeElement.value = "";
        this.dataimg = this.defaultUl;
        return;
      } else {
        this.dataimg = events.currentTarget.result;
        this.imagearr = [{
          filename: event.target.files[0].name,
          filetype: event.target.files[0].type,
          value: events.currentTarget.result.split(',')[1]
        }];
      }

    }
  }



  getBpci(dob) {


    let diff_ms = Date.now() - dob.getTime();
    //let diff_ms = Date.now();
    let age_dt = new Date(diff_ms);

    let age = Math.abs(age_dt.getUTCFullYear() - 1970);
    if (age >= 65) {
      return 'Yes';
    }
    if (age < 65) {
      return 'No'
    }
  }


  checkForm(f: NgForm) {
    //////console.log("f",f)
  }

  setMRNnull(event) {
    let self = this;
    if (self.patientdetail.mrnNo) {
      self.patientdetail.mrnNo = '';
    }
  }

  setssnnull(event) {
    let self = this;
    if (self.patientdetail.ssn) {
      self.patientdetail.ssn = ''
    }
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  emailChanged: boolean = false;
  note(e) {
    this.emailChanged = true;
    this.emailstatus = this.validateEmail(this.patientdetail.email)
    if (!this.emailstatus && this.patientdetail.email != "") {
      this.patientdetail.email = ""
      this.validatemail = true
      /* this.toast.error("Enter valid email address", '', {
        timeOut: this.timealert
      }) */
    }
    else if (!this.emailstatus && this.patientdetail.email == "") {
      this.patientdetail.email = ""
      this.validatemail = false
    }
    if (this.patientStatus != 'Not Enrolled' && this.patientStatus != 'Opted-Out' && this.patientStatus != 'Invited') {
      this.invited = false;
      if (!this.patientdetail.email && !this.patientdetail.phone) {
        this.required = true
      }
      else if (this.patientdetail.email && this.patientdetail.phone) {
        this.required = false
      }
      else if (!this.patientdetail.email) {
        this.required = true
      }
      else if (!this.patientdetail.phone) {
        this.required = false
      }
    }
    this.show = e;
    if (e == this.patientdetail.email) {
      this.status = true;
    }
    else if (e != this.patientdetail.email) {
      this.status = false;
    }
  }

  pho(e) {
    if (this.patientStatus != 'Not Enrolled' && this.patientStatus != 'Opted-Out' && this.patientStatus != 'Invited') {
      // if (!this.patientdetail.email && !this.patientdetail.phone) {
      //   this.required1 = true
      // }
      // else 
      if (this.patientdetail.email && this.patientdetail.phone) {

        this.required1 = false
      }
      else if (!this.patientdetail.email) {

        this.required1 = false
      }
      else if (!this.patientdetail.phone) {

        this.required1 = false
      }

    }
    this.showph = e;
    // ////console.log("event", e)
    this.phonevalue = false
    if (this.setmask.length != this.maxlen && this.maxlen > 14) {
      this.setmask = this.currentUser.item.phoneFormat.split('#').join('0').concat('0')
    } else {
      this.setmask = this.currentUser.item.phoneFormat.split('#').join('0')
    }
  }
  pho1(e) {
    this.phonevalueOther = false
    if (this.setmask1.length != this.maxlen1 && this.maxlen1 > 14) {
      this.setmask1 = this.currentUser.item.phoneFormat.split('#').join('0').concat('0')
    } else {
      this.setmask1 = this.currentUser.item.phoneFormat.split('#').join('0')
    }
  }
  phonealert: boolean = false
  editpatient(ed, temppassword, userdetails) {
    if (this.phonealert && !this.duplicateshow)
      this.phonechange(ed, temppassword)
    else if (this.checkEmailClear && !this.duplicateshow)
      this.emailchange(ed, temppassword)
    else
      this.savedetails(ed, temppassword)
  }
  onphochange(event) {
    if (event) {
      this.phonealert = true
    }
  }
  emailchange(ed, temppassword) {
    if (this.patientdetail.email) {
      if (this.validateEmail(ed.value.email)) {
        let data = {
          "oldEmail": this.temMail,
          "newEmail": this.patientdetail.email,
          "oldPhone": '',
          "newPhone": '',
          "addOrEdit": 'edit',
          "updatingProfileRole": 19
        }
        this.userExists(data, ed, temppassword)
      }
    }
    else {
      this.savedetails(ed, temppassword)
    }

  }
  phonechange(ed, temppassword) {

    let self = this;
    //check phone number is already exists
    let code = this.patientdetail.code.split(',')
    if (self.patientdetail.phone && code[0] + this.tempphone != code[0] + this.patientdetail.phone) {
      let phone = code[0] + '-' + self.patientdetail.phone
      let tempcode = this.tempCode.split(',')
      let temPhone = ''
      if (this.tempphone) {
        temPhone = tempcode[0] + '-' + this.tempphone
      }
      let data = {
        "oldEmail": '',
        "newEmail": '',
        "oldPhone": temPhone,
        "newPhone": phone,
        "addOrEdit": 'edit',
        "updatingProfileRole": 19
      }
      this.userExists(data, ed, temppassword)
    } else {
      this.savedetails(ed, temppassword)
    }
  }
  userExists(data, ed, temppassword) {
    this.patientservice.getUserExist(data, this.currentUser.item.userAccountKey)
      .subscribe(data => {
        if ((data.popUpStatus == 'true' && data.status == 'success') || data.message == 'User already Exist')
          return;
        else {
          this.savedetails(ed, temppassword)
        }
      });
  }
  savedetails(ed, temppassword) {
    this.validatemail = false
    this.showloader = true;
    if (this.payortype == 'Medicare')
      ed.value.bpci = 'Yes'
    // ed.value.bpci = this.getBpci(ed.value.dob)
    else {
      ed.value.bpci = 'No'
    }

    if(!ed.value.email && !ed.value.phone) {
			this.toast.error(this.userService.translateText('patient_portal.display_messages.mobole_email_valdation.error'), '', {
				timeOut: this.timealert
			})
      this.showloader = false;
			return;
		}
    ed.value.PatientSWFId = this.params.patientSWFId
    ed.value.loginUaId = this.selectedUserId
    ed.value.updateimage = this.imagearr;
    if (this.imagearr == undefined) {
      ed.value.updateimage = [];
    }
    ed.value.dob = this.datepipe.transform(ed.value.dob, 'yyyy-MM-dd');
    // ////console.log(ed.value);
    if (ed.value.code) {
      ed.value.code = this.patientdetail.code
      let telecode = ed.value.code.split(',')
      ed.value.teleCode = telecode[0]
      ed.value.teleCountryCode = telecode[1]
    } else {
      ed.value.teleCode = ''
      ed.value.teleCountryCode = ''
    }


    if (ed.value.phone.includes("(") || ed.value.phone.includes(" ")) {
      ed.value.phone = this.patientdetail.phone.replace(/[^A-Z0-9]/ig, "")
    }
    if (ed.value.codeOther) {
      ed.value.codeOther = this.patientdetail.codeOther
      let telecode = ed.value.codeOther.split(',')
      ed.value.teleCodeOther = telecode[0]
      ed.value.teleCountryCodeOther = telecode[1]
    } else {
      ed.value.codeOther = ''
      ed.value.teleCodeOther = ''
      ed.value.teleCountryCodeOther = ''
    }

    if (ed.value.phoneOther) {
      if (ed.value.phoneOther.includes("(") || ed.value.phoneOther.includes(" ")) {
        ed.value.phoneOther = this.patientdetail.phoneOther.replace(/[^A-Z0-9]/ig, "")
      }
    } else {
      ed.value.phoneOther = ''
    }
    if (!ed.value.mrnNo) {
      ed.value.mrnNo = '';
    }
    if (!ed.value.hic) {
      ed.value.hic = '';
    }


    if (this.checkEmailClear && !ed.value.email) {
      ed.value.email = this.setEmailValue;
      // console.log("ed.value.email", ed.value.email)
    }

    if (this.checkPhoneClear && !ed.value.phone) {
      ed.value.phone = this.setPhoneValue;
      // console.log("ed.value.phone", ed.value.phone)
    }

    this.patientservice.SummaryUpdateProfile(this.params.patientId, ed.value)
      .subscribe(
        data => {
          this.showloader = false;
          if (data.updateStatus == "true") {
            ed.resetForm();
            this.phoneOthervalue = false
            this.phonevalueOther = false;
            this.reass = false
            this.checkFormDisable = false;

            this.bindEditLoad();
            this.getAppoinments()
            this.getPatientDetailspat()
            //this.getScanDocuments();
            this.getmenu();
            this.getAssement();
          }

          if (data.updateStatus == "true" && !this.status && !this.emailcheck && !this.mobile) {
            if (this.openpopup) {
              this.close()
            }
            this.respass = this.userService.translateText('patient_portal.display_messages.update_message');
            this.reset('', true)
            this.userService.logAudit('SummaryUpdateProfile', 0).subscribe(data => { })
            this.modalRef = this.modalService.show(temppassword, { class: 'modal-sm', backdrop: 'static' });
            this.movable()
            this.resp = " ";

            // this.nav.navigate([`care/patientdetail/${this.params.patientId}/${this.params.patientSWFId}/${this.params.patstatus}/${this.params.status}`]);

          } else if (data.updateStatus == "true" && this.status && !this.emailcheck && !this.mobile && this.show) {
            if (this.openpopup) {
              this.close()
            }
            this.respass = this.userService.translateText('hospital_portal.disp_messages.updated_patient_email.success');
            this.modalRef = this.modalService.show(temppassword, { class: 'modal-sm', backdrop: 'static' });
            this.movable()
            this.resp = " ";

            // this.nav.navigate([`care/patientdetail/${this.params.patientId}/${this.params.patientSWFId}/${this.params.patstatus}/${this.params.status}`]);
            this.status = false
            this.emailcheck = false
          } else if (data.updateStatus == "true" && !this.status && !this.emailcheck && this.mobile && this.showph) {
            if (this.openpopup) {
              this.close()
            }
            this.respass = this.userService.translateText('hospital_portal.disp_messages.updated_patient_mobile.success');;
            this.modalRef = this.modalService.show(temppassword, { class: 'modal-sm', backdrop: 'static' });
            this.movable()
            this.resp = " ";
            this.mobile = false;
            this.emailcheck = false;
          } else if (data.updateStatus == "true") {
            if (this.openpopup) {
              this.close()
            }
            this.respass = this.userService.translateText('patient_portal.display_messages.update_message');
            this.modalRef = this.modalService.show(temppassword, { class: 'modal-sm', backdrop: 'static' });
            this.movable()
            this.resp = " ";
            this.mobile = false;
            this.show = "";
            this.showph = "";
            this.emailcheck = false;

          }
          else if (data.updateStatus != "true") {
            // this.resp = data.updateStatus;
          }

        }


      );
  }
  close() {
    this.modalRef1.hide();
    this.openpopup = false;
  }
  mailclose() {
    this.modalRef1.hide();
    this.patientservice
      .getpatientdetails(this.params.patientId)
      .subscribe(
        data => {
          for (var i = 0; i < data.length; i++) {
            this.patientdetail = data[i];
            this.temMail = data[i].email;
            let x, y, k, m
            if (this.patientdetail.phone) {
              this.tempphone = this.patientdetail.phone
              this.patientdetail.code = this.patientdetail.teleCode + ',' + this.patientdetail.teleCountryCode

              this.phonevalue = true
              x = this.patientdetail.phone.split("");
              y = []
              k = []
              m = []
              if (this.currentUser.item.language != 'en_uk') {
                for (var e = 0; e < 3; e++) {
                  y[e] = x[e]
                }
                for (var r = 3; r < 6; r++) {
                  k[r] = x[r]
                }
                for (var t = 6; t < x.length; t++) {
                  m[t] = x[t]
                }
                this.patientdetail.phone = '(' + y.join('') + ') ' + k.join('') + '-' + m.join('')
              }
              else {
                for (var h = 0; h < 5; h++) {
                  y[h] = x[h]
                }
                for (var o = 5; o < x.length; o++) {
                  m[o] = x[o]
                }
                this.patientdetail.phone = y.join('') + ' ' + m.join('')
              }
            } else if (this.patientdetail.phoneOther) {
              this.tempphoneOther = this.patientdetail.phoneOther
              this.patientdetail.codeOther = this.patientdetail.teleCodeOther + ',' + this.patientdetail.teleCountryCodeOther

              this.phoneOthervalue = true
              this.phonevalueOther = true
              x = this.patientdetail.phoneOther.split("");
              y = []
              k = []
              m = []
              if (this.currentUser.item.language != 'en_uk') {
                for (var c = 0; c < 3; c++) {
                  y[c] = x[c]
                }
                for (var b = 3; b < 6; b++) {
                  k[b] = x[b]
                }
                for (var u = 6; u < x.length; u++) {
                  m[u] = x[u]
                }
                this.patientdetail.phoneOther = '(' + y.join('') + ') ' + k.join('') + '-' + m.join('')
              }
              else {
                for (var w = 0; w < 5; w++) {
                  y[w] = x[w]
                }
                for (var p = 5; p < x.length; p++) {
                  m[p] = x[p]
                }
                this.patientdetail.phoneOther = y.join('') + ' ' + m.join('')
              }
            }
            else {
              if (this.currentUser.item.language != 'en_uk') {
                this.patientdetail.code = '+1,USA'
                this.patientdetail.codeOther = '+1,USA'
              } else if (this.currentUser.item.language == 'en_uk') {
                this.patientdetail.code = '+44,UK'
                this.patientdetail.codeOther = '+44,UK'
              }
              if (this.currentUser.item.clientTeleCode) {
                this.patientdetail.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
                this.patientdetail.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
              }
            }

            this.checkphonelength(this.patientdetail.code);
            this.checkphonelength1(this.patientdetail.codeOther);
            //this.checkphonlength(this.patientdetail.code)
            //this.checkphonlength1(this.patientdetail.codeOther)
            // ////console.log("code", this.patientdetail.code);
          }
          this.dataimg = this.imageURL + data[0].Imagepath;
          // ////console.log("email", this.patientdetail.email);
          this.getPatientDetails();

        }

      );
  }

  getSide(side) {
    if(side == 'Left') {
      return this.userService.translateText('hospital_portal.body_part.left.label')
    } else if(side == 'Right') {
      return this.userService.translateText('hospital_portal.body_part.right.label')
    } else if(side == 'Bilateral') {
      return this.userService.translateText('hospital_portal.body_part.bilateral.label')
    }
  }
  
  procedurepatient(pr) {
    this.showloader = true
    pr.value.userAccountId = window.localStorage['superClientId'] ? window.localStorage['superClientId'] : this.currentUser.item.userAccountId
    pr.value.patientSwfId = parseInt(this.params.patientSWFId);
    if (this.patientdetail.mako == 'Yes') {
      pr.value.mako = 'Yes'
    } else {
      pr.value.mako = 'No'
    }
    if (this.patientdetail.cjr) {
      pr.value.cjr = 'Yes'
    } else {
      pr.value.cjr = 'No'
    }
    if (this.payortype == 'Medicare' && !this.patientdetail.cjr && this.clienttype && this.clienttype.search("BPCIA") != -1)
      pr.value.bpci = 'Yes'
    // ed.value.bpci = this.getBpci(ed.value.dob)
    else {
      pr.value.bpci = 'No'
    }
    if (pr.value.procedureType == 'Partial Hip Replacement' || pr.value.procedureType == 'Hip and Femur Fracture (SHFFT)') {
      pr.value.frac = true
    }
    pr.value.fracture = pr.value.frac ? pr.value.frac : false;
    // ////console.log(pr.value)
    if (pr.value.location == 'Back') {
      pr.value.laterality = 'Back'
    } else if (pr.value.location == 'Neck') {
      pr.value.laterality = 'Neck'

    }
    if (this.hspId) {
      pr.value.dropDownSOSId = this.hspId;
    }

    this.patientservice.Procedureupdate(pr.value)
      .subscribe(
        data => {
          // this.showloader = false;
          pr.resetForm()
          if (data.status) {
            this.toast.success(data.message, '', {
              timeOut: this.timealert
            })
            this.userService.logAudit('changeProcedureDetails', 0).subscribe(data => { })
            this.reset('')
            this.showloader = false
          }
          else {
            this.toast.error(data.message, '', {
              timeOut: this.timealert
            })
            this.showloader = false
          }



        }

      );
  }
  dateValueChange(event) {
    if (event.inputType != 'deleteContentBackward') {
      if (event.target.value.length == 2 || event.target.value.length == 5) {
        var thisVal = event.target.value;
        thisVal += '/';
        event.target.value = thisVal;
      }
    }
  }

  checkempty(id) {
    // ////console.log(id)
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild = true
    } else if (id != '' && id != null) {
      this.showinvaild = false
    }
  }
  shospital0: any;
  check0(id) {
    // ////console.log(id)
    if (id == '' || id == null) {
      this.shospital0 = true
      // ////console.log("true")
    } else if (id != '' && id != null) {
      this.shospital0 = false
      // ////console.log("false")
    }

  }
  check1(id) {
    // ////console.log(id)
    if (id == '' || id == null) {
      this.shospital1 = true
      // ////console.log("true")
    } else if (id != '' && id != null) {
      this.shospital1 = false
      // ////console.log("false")
    }

  }

  check2(id) {
    // ////console.log(id)
    if (id == '' || id == null) {
      this.shospital2 = true
      // ////console.log("true")
    } else if (id != '' && id != null) {
      this.shospital2 = false
      // ////console.log("false")
    }

  }
  check3(id) {
    // ////console.log(id)
    if (id == '' || id == null) {
      this.shospital3 = true
      // ////console.log("true")
    } else if (id != '' && id != null) {
      this.shospital3 = false
      // ////console.log("false")
    }

  }
  check4(id) {
    // ////console.log(id)
    if (id != 0) {
      if (id == '' || id == null) {
        this.shospital4 = true
        // ////console.log("true")
      } else if (id != '' && id != null) {
        this.shospital4 = false
        // ////console.log("false")
      }
    } else {
      this.shospital4 = false
    }

  }
  check5(id) {
    // ////console.log(id)
    if (id == '' || id == null) {
      this.shospital5 = true
      // ////console.log("true")
    } else if (id != '' && id != null) {
      this.shospital5 = false
      // ////console.log("false")
    }

  }
  checked(value) {
    this.hiddenchecked = true;
    if (value) {
      this.showcross = true;
    }

  }
  clearBodyPart(i) {
    let self = this;
    self.patientdetail.location = ''
    self.patientdetail.laterality = ''
  }
  getBodyParts(event) {

    if (event == "Shoulder") {
      this.bodyparttype = true;
    } else {
      this.bodyparttype = false;
    }
  }
  getbundlepayortypeprocedure(id) {
    let self = this;
    self.patientservice.getBundlepartType(this.currentUser.item.userAccountKey, id)
      .subscribe(data => {

        this.patientdetail.procedure = ''
        this.patientdetail.procedureDisplayName = ''
        this.patientdetail.laterality = ''

        this.payortypechange = data
        ////console.log(this.payortypechange)
      })
  }
  getvalue() {
    if (this.dosStatus || this.params.status) {
      return true
    } else {
      return false
    }
  }

  checkphonelength(e) {
    if (e) {
      let phone = this.patientdetail.phone.split('(').join('')
      phone = phone.split(')').join('')
      phone = phone.split(' ').join('')
      phone = phone.split('-').join('')
      if (phone != this.tempphone)
        this.patientdetail.phone = "";
      if (this.patientdetail.phone) {
        this.phonevalue = true
      }
      else if (!this.patientdetail.phone) {
        this.phonevalue = false
      }
      this.i++
      let telecode = e.split(',')
      let codecoun = telecode[1]
      this.phonecountrycode(codecoun, false)
    }
  }
  checkphonelength1(e) {
    if (e) {
      let phoneOther = this.patientdetail.phoneOther.split('(').join('')
      phoneOther = phoneOther.split(')').join('')
      phoneOther = phoneOther.split(' ').join('')
      phoneOther = phoneOther.split('-').join('')
      if (phoneOther != this.tempphoneOther)
        this.patientdetail.phoneOther = "";
      if (this.patientdetail.phoneOther) {
        this.phonevalueOther = true
      }
      else if (!this.patientdetail.phoneOther) {
        this.phonevalueOther = false
      }
      this.i++
      let telecode = e.split(',')
      let codecoun = telecode[1]
      this.phonecountrycode(codecoun, true)
    }
  }
  checkphonlength(e) {
    if (e) {
      let telecode = e.split(',')
      let phoneOther, teleCodeOther
      teleCodeOther = this.patientdetail.codeOther.split(',')
      if (this.patientdetail.phoneOther) {
        phoneOther = this.patientdetail.phoneOther.split('(').join('')
        phoneOther = phoneOther.split(')').join('')
        phoneOther = phoneOther.split(' ').join('')
        phoneOther = phoneOther.split('-').join('')
      }
      if (telecode[0] + this.patientdetail.phone == teleCodeOther[0] + phoneOther && this.patientdetail.phoneOther) {
        this.toast.error(this.userService.translateText('hospital_portal.disp_messages.mob_no_should_not_same.error'), '', {
          timeOut: this.timealert
        })
        return this.patientdetail.phone = ''
      } else {

        let telecode = e.split(',')
        let codecoun = telecode[1]
        this.phonecountrycode(codecoun, false)

      }
    }
  }
  phonecountrycode(codecoun, other) {
    this.userService.phonebycountrycode(codecoun)
      .subscribe(
        data => {
          if (other) {
            this.setlength1 = data.Length;
            this.maxlen1 = data.Length + this.currentUser.item.length;
            if (data.Length == 11) {
              this.setmask1 = this.currentUser.item.phoneFormat.split('#').join('0').concat('0')
            } else {
              this.setmask1 = this.currentUser.item.phoneFormat.split('#').join('0')
            }
          } else {
            this.setlength = data.Length;
            this.maxlen = data.Length + this.currentUser.item.length;
            if (data.Length == 11) {
              this.setmask = this.currentUser.item.phoneFormat.split('#').join('0').concat('0')
            } else {
              this.setmask = this.currentUser.item.phoneFormat.split('#').join('0')
            }
          }
        }
      );
  }
  checkphonlength1(e) {
    if (e) {
      let telecode = e.split(',')
      let codecoun = telecode[1]
      let phone, teleCodeOther
      if (this.patientdetail.phone) {
        teleCodeOther = this.patientdetail.code.split(',')
        phone = this.patientdetail.phone.split('(').join('')
        phone = phone.split(')').join('')
        phone = phone.split(' ').join('')
        phone = phone.split('-').join('')
      }
      if (teleCodeOther[0] + phone == telecode[0] + this.patientdetail.phoneOther && this.patientdetail.phone) {
        this.toast.error(this.userService.translateText('hospital_portal.disp_messages.mob_no_should_not_same.error'), '', {
          timeOut: this.timealert
        })
        return this.patientdetail.phoneOther = ''
      } else {
        this.phonecountrycode(codecoun, true)
      }
    }
  }
  getdate(date) {
    if (this.currentUser.item)
      if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
        return this.datepipe.transform(date, environment.dateForm);
      } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
        return this.datepipe.transform(date, 'dd/MM/yyyy');
      }
  }
  getdatetime(date) {
    if (this.currentUser.item)
      if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
        return this.datepipe.transform(date, 'MM/dd/yyyy hh:mm a');
      } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
        return this.datepipe.transform(date, 'dd/MM/yyyy hh:mm a');
      }
  }

  //----pats start vimal--- changes 21-06-2019
  updatedetils(status, uid) {
    // ////console.log(this.patid);
    if (!this.disabled) {
      var patname = this.patientinfo.PatientFirstName + ' ' + this.patientinfo.PatientLastName
      let careDetails = {
        'patientId': this.patid.patientId,
        'patientSWFId': this.patid.patientSWFId,
        'patientName': patname,
        'patstatus': this.patid.patstatus,
        'status': this.patid.status,
        'partnerstatus': status,
        'uid': uid
      }
      window.localStorage['careDetails'] = btoa(JSON.stringify(careDetails))
      this.nav.navigate([`care/addpartner`])
    }
  }


  updategiver() {
    //////console.log();
    let careGiverDetails = {
      'patientId': this.patid.patientId,
      'patientSWFId': this.patid.patientSWFId,
      'statusid': this.carepath.Status,
      'patstatus': this.params.patstatus,
      'status': this.params.status
    }
    window.localStorage['careGiverDetails'] = btoa(JSON.stringify(careGiverDetails))
    this.nav.navigate([`care/addgiver`])
  }
  getAppoinments() {
    this.patientservice
      .getapp(this.patid.patientSWFId)
      .subscribe(
        data => {

          this.getapp = data;
        }
      );
  }
  getPatientDetailspat() {
    let self = this;
    self.patientservice.getpatientinfo(self.patid.patientId, self.patid.patientSWFId)
      .subscribe(data => {

        if (Array.isArray(data) && data.length) {
          self.user = data[0]
        }

      })
  }
  getScanDocuments() {
    this.patientservice
      .getdocuments(this.patid.patientId, this.patid.patientSWFId)
      .subscribe(
        data => {

          this.documentsdata = data;
          //////console.log(this.documentsdata);
        }
      );
  }
  clearall() {
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.pad.title = '';
    this.pad.note = '';
    this.resabs = " ";
  }

  postdoc(temppassword, da) {
    this.enableshow = true;
    this.enable = false;
    if (this.imageChangedEvent.srcElement != undefined) {
      this.datapost = {
        "docTitle": da.value.title,
        "docNote": da.value.note,
        "patientId": this.patid.patientId,
        "PatientSWFId": this.patid.patientSWFId,
        "uploadimage": [{
          "filename": this.imageChangedEvent.srcElement.files[0].name,
          "filetype": this.imageChangedEvent.srcElement.files[0].type,
          "value": this.croppedImage.split(',')[1]
        }]

      }

      this.patientservice.postdocuments(this.datapost)
        .subscribe(
          data => {

            ////console.log(data, this.datapost);
            if (data) {
              this.enableshow = true;

              this.enable = false;

              this.modalRef.hide();
              this.respass = this.userService.translateText('hospital_portal.disp_messages.document_added.success');
              this.modalRef = this.modalService.show(temppassword, {
                class: 'modal-sm',
                backdrop: 'static'
              });
              this.movable()
              //this.getScanDocuments();
              this.imageChangedEvent = '';
              this.croppedImage = '';
              this.pad.title = '';
              this.pad.note = '';
              this.datapost = {};
            }
            else {
              this.enableshow = true
              this.enable = false;
              this.respass = this.userService.translateText('hospital_portal.disp_messages.enter_valid_data.error');
            }
            //this.getScanDocuments();
            this.enableshow = false;
            this.enable = true;
          }
        );
    }
    else {
      this.resabs = this.userService.translateText('hospital_portal.disp_messages.upload_img.error');
    }
  }

  navgiater() {
    this.activestatus = true
  }

  getAppoinmentsList(id) {
    let self = this;
    self.patientservice.getAppoinmentsListwitSWFid(id).subscribe(
      data => {
        self.checkDos = new Date(self.user.dos)
        self.patientAppoinmentList = _.map(data, self.changeDateFormat)
      }
    )
    //====pats end ---
  }

  //chnage the date formate for date picker

  changeDateFormat(n) {
    if (n.appointmentDate) {
      n.appointmentDate = new Date(n.appointmentDate)
    }
    if (n.completedDate) {
      n.completedDate = new Date(n.completedDate);
    }
    return n
  }
  //check current appointment can editable
  checkAppoinment(i) {
    let self = this;
    var booleanArray = [];
    for (let j = i; j < 5; j++) {
      if (self.patientAppoinmentList[j].completedDate) {
        booleanArray.push(true)
      }
    }
    if (booleanArray.length) {
      return booleanArray.includes(true)
    } else {
      return false;
    }
  }
  saveAppoinments() {
    let self = this;
    self.changeDateFormat(self.patientAppoinmentList)
    let loginHospitalId: any;
    loginHospitalId = this.currentUser.item ? this.currentUser.item.userAccountKey : 0;
    self.arrangaData(self.patientAppoinmentList).then(
      data => {
        self.patientservice.saveAppoinments(data, loginHospitalId, this.patid.patientSWFId)
          .subscribe(
            data => {
              self.toast.success(data[0].message, '', {
                timeOut: this.timealert
              });
              this.userService.logAudit('savePatientAppointment', 0).subscribe(data => { })
              self.getAppoinments()
              self.modalRef.hide()
            }
          )
      }, err => {

      }
    )
  }
  checkTime(event, i) {
    let self = this;
    if (event) {
      if (self.patientAppoinmentList[i].appointmentDate) {
        let today = new Date();
        let timeNow = new Date().getHours();
        let min = new Date().getMinutes();
        let appointmentDate = new Date(self.patientAppoinmentList[i].appointmentDate)
        if (today.setHours(0, 0, 0, 0) == appointmentDate.setHours(0, 0, 0, 0)) {
          if (min > 30) {
            self.mintimeset = timeNow + 1;
          } else {
            self.mintimeset = timeNow + 0.5;
          }
        } else {
          self.mintimeset = 0;
        }
      }
    }

  }
  arrangaData(dataArray) {
    let self = this;

    let promise = new Promise((resolve, reject) => {
      for (let i = 0; i < dataArray.length; i++) {
        if (dataArray[i].appointmentDate) {
          if (!dataArray[i].appoinmentWithId) {
            self.toast.error(this.userService.translateText('hospital_portal.disp_messages.select_surgeon_name.error')+ '${dataArray[i].appointmentTitle}', '', {
              timeOut: this.timealert
            })
            reject("Error");
          }
        }
        if (!dataArray[i].appointmentDate) {
          dataArray[i].appointmentDate = null;
        }
        if (!dataArray[i].appointmentTime) {
          dataArray[i].appointmentTime = null
        }
      }
      resolve(dataArray)
    })
    return promise
  }
  cancelAppointment(index, data) {
    let self = this;
    if (data.appointmentDate && data.appoinmentWithId) {
      self.patientservice.cancelAppoinments(data).subscribe(
        res => {
          if (index == 0) {
            self.patientAppoinmentList[index].appointmentTime = 0;
          }
          self.patientAppoinmentList[index].appointmentDate = '';
          self.patientAppoinmentList[index].appoinmentWithId = '';
          self.toast.success(this.userService.translateText('hospital_portal.appointments.appointment_was_cancelled.error'), '', {
            timeOut: this.timealert
          });
          this.userService.logAudit('cancelPatientAppointment', 0).subscribe(data => { })
          // self.getAppoinmentsList(data.patientSwfId)
        }
      )
    }
  }

  /* addcareimgurl -*/
  /* Care navigator Reassign Change */
  reass: boolean = false;
  public reassign: any = {}
  selCare: string;
  lengthcn: any;
  careList: any;
  public caremap: any = environment.practiceid;

  carenav(event, showassign: TemplateRef<any>, todoConfig: TemplateRef<any>) {
    let stykeradmin = window.localStorage['superClientId']
    this.reassign = {
      assignedTo: event,
      assignedFrom: this.patientservice.CN_id ? this.patientservice.CN_id : 0,
      patSWFId: this.params.patientSWFId,
      userAccId: this.currentUser.item.userAccountId,
      userAccountKey: this.currentUser.item.userAccountKey,
      stykerAdmin: stykeradmin ? stykeradmin : 0
    }

    this.getTodoConfigurationStatus(this.reassign.userAccId, this.reassign.assignedTo, showassign, todoConfig);

    this.movable()

  }

  getConfigtodo: any;
  getTodoConfigurationStatus(userAccId, assignedTo, showassign, todoConfig) {
    this.patientservice.getTodoConfigurationStatus(this.reassign)
      .subscribe(data => {
        this.getConfigtodo = data;

        if (this.getConfigtodo.Status == 'true') {
          this.modalRef1 = this.modalService.show(todoConfig, {
            class: 'modal-sm'
          })
        }
        else {
          this.modalRef1 = this.modalService.show(showassign, {
            class: 'modal-sm'
          })
        }
      })
  }


  loadCareList() {
    this.userService.getCareList(this.currentUser.item.userAccountKey, this.currentUser.item.userAccountId)
      .subscribe(
        data => {
          this.careList = data;
          this.lengthcn = this.careList.length
          if (this.currentUser.item.cnmappingct == 0 || this.currentUser.item.userAccountId == this.caremap) {
            this.selCare = 'ALL'
          } else {
            this.selCare = data.find(it => it.CNID == this.currentUser.item.userAccountId).CNID;
            this.currentUser.item.selectCNUserId = this.selCare;
          }
          this.selCare = ''
        }
      );
  }

  changeModalref: BsModalRef;
  showselect(ed, pr, patientChange: TemplateRef<any>, procedureChange: TemplateRef<any>, cn) {
    if (ed.submitted || ed.dirty) {
      //alert('Patient Dirty')
      this.changeModalref = this.modalService.show(patientChange, { class: 'modal-sm', backdrop: 'static', keyboard: false })
    }
    else if (pr.submitted || pr.dirty) {
      //alert('Procedure Dirty')
      this.changeModalref = this.modalService.show(procedureChange, { class: 'modal-sm', backdrop: 'static', keyboard: false })
    }
    else {
      this.selCare = cn
      this.reass = true;
    }
  }

  checkFormDisable: boolean = false;
  checkFormData(ed, pr, patientChange: TemplateRef<any>, procedureChange: TemplateRef<any>) {
    if (ed.submitted || ed.dirty) {
      //alert('Patient Dirty')
      this.checkFormDisable = true;
      this.changeModalref = this.modalService.show(patientChange, { class: 'modal-sm', backdrop: 'static', keyboard: false })

    }
    else if (pr.submitted || pr.dirty) {
      //alert('Procedure Dirty')
      this.checkFormDisable = true;
      this.changeModalref = this.modalService.show(procedureChange, { class: 'modal-sm', backdrop: 'static', keyboard: false })
    }
  }


  yestoshow() {
    this.showloader = true;
    this.reass = true;
    this.patientservice
      .reassigncn(this.reassign)
      .subscribe(
        data => {
          if (data) {

            this.toast.toastrConfig.timeOut = environment.timelimit;
            this.toast.success(this.currentUser.item.userrole + " "+ this.userService.translateText('hospital_portal.disp_messages.reassign_success.success'));
            this.userService.logAudit("Cn Reassign", 0).subscribe(data => { })
            this.showloader = false;
            this.reass = false;
            this.patientservice
              .getuserdetails(this.params.patientSWFId, this.uid)
              .subscribe(
                data => {
                  if (Array.isArray(data) && data.length) {
                    this.cn = data[0].caseManager
                    ////console.log("user", this.user)
                  }
                })
          }
        }
      );
    this.modalRef1.hide();

  }
  notoshow() {
    this.selCare = '';
    this.modalRef1.hide();
    this.reass = false;
  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }


  // Location of DOS Chnage
  DOSChangeDate: any;
  textTemplate15: any;
  mindos: any;
  dosStatusop: any;
  planneddisabled: any;
  enablepatient: boolean = false
  saveBtnEnable: boolean = false
  createPACEventbtn: boolean = false
  public carePath: any = {
    selCare: '',
    dischargeTypeList: [],
    dischargehospitalList: [],
    dcode: '+1,USA',
    name: 'Community Hospital',
    dos: ''
  };
  dayinterval: any;
  configuredate: number = 5;
  PACEventsData: any = [];
  ModelRef41: any;
  /**** Calling on DOS Change function ****/
  getAllEventList() {
    this.patientservice.getCarePlanDetails(this.patid.patientSWFId, this.currentUser.item.userAccountId)
      .subscribe(data => {

        if (data.length > 0) {
          this.carePath = data[0];
          this.carePath.dos = new Date(this.carePath.dos);
          if (this.carePath.dos) {
            this.bobMaxDate = new Date(this.carePath.dos)
          }
        }
        else {
          this.carePath = {
            dos: ''
          }
        }
        this.PACEventsData = data;

        ////console.log("PACEventsData", this.PACEventsData)
      });
  }

  configPlannedIntervalData: any;
  checkconfiguredate() {
    this.configuredate = 5
    this.patientservice.getPlannedDischargeDate(this.patid.patientSWFId)
      .subscribe(data => {
        this.configPlannedIntervalData = data;
        /*  if (data.confPlannedFacilityDischargeDate) {
          this.configuredate = parseInt(data.confPlannedFacilityDischargeDate)
        } */
      })
    ////console.log(this.configuredate)
  }


  getPlannedDayInterval(dischargeTypeId) {
    if (dischargeTypeId != -1) {
      for (var item of this.configPlannedIntervalData) {
        if (item.dischargeTypeId == dischargeTypeId)
          return item.facilityDischargeDayInterval;
      }
      if (dischargeTypeId == 6)
        return 1;
      else
        return 5;
    } else {
      if (isNaN(this.dayinterval)) {
        return 3
      }
      return this.dayinterval;
    }
  }
  getPlannedInterval() {
    this.patientservice.getHospitalPlannedDischargeDateInterval(this.hospitalid, this.params.patientSWFId)
      .subscribe(data => {
        this.dayinterval = data.plannedDischargeDayValue;
      })
  }
  SetPDosStatus(event, template15) {

    this.textTemplate15 = false;



    if (event) {
      let self = this;
      let date = this.datepipe.transform(event, this.dateform);

      var dateStr = this.changeStringFormat2(event);
      this.DOSChangeDate = dateStr;

      if (date) {

        this.saveBtnEnable = false;
        this.createPACEventbtn = false;

        /* New Code */
        this.enablepatient = false;

        let toDate = new Date();
        toDate.setDate(toDate.getDate() - 1);
        this.mindos = new Date(this.patientdetail.dob)
        let dob = this.mindos.getTime();
        let bDos = new Date(date);
        bDos.setDate(bDos.getDate() + 1)
        if (dob > bDos.getTime()) {
          self.toast.error(this.userService.translateText('hospital_portal.add_patient.dos_less_then_dob.error'), '', {
            timeOut: this.timealert
          });
          return;
        }



        let Dos = new Date(date);

        if (toDate.getTime() <= Dos.getTime()) {
          self.dosStatusop = "future"
        }
        if (toDate.getTime() > Dos.getTime()) {
          self.dosStatusop = "past"
          for (var itractionObj of this.PACEventsData) {
            if (this.dosStatusop == 'past' && itractionObj.hospitalStay && itractionObj.actualDischargeDate) {
              itractionObj.actualDischargeDate = ''
              itractionObj.pacFinished = false
              itractionObj.trackActualVisible = false
            }
          }
          //self.carePath.plannedDischargeId = ""
        }
        if (!self.carePath.plannedDischargeDate) {
          self.setDOSPlannedDate(event, template15)
        }
      } else {
        self.dosStatusop = 'notSelected'
      }

      if (this.PACEventsData.length <= 0)
        this.createPACEventbtn = true;

    }
    else {

      /* New Code */
      this.enablepatient = true;
      this.saveBtnEnable = true;
      this.createPACEventbtn = true;
    }
    if (this.PACEventsData.length > 0) {
      this.onDOSChangePacEventValidate();
      this.onTopDOSDateChange();
    }
    var dosfuture;
    for (var item of this.PACEventsData) {
      if (item.hospitalStay) {
        item.anonymousSnfDischargeDate = new Date(item.anonymousSnfDischargeDate)
        if (item.trackActualVisible && item.pacFinished && this.carePath.dos.setHours(0, 0, 0, 0) > item.anonymousSnfDischargeDate.setHours(0, 0, 0, 0)) {
          this.textTemplate15 = true

        }
      }
    }

  }
  setDOSPlannedDate(event, template15) {
    let self = this;
    if (event) {
      if (!self.carePath.plannedDischargeDate) {
        let configuredate: any = 3
        self.patientservice.getPlannedDischargeDate(self.patid.patientSWFId)
          .subscribe(data => {
            if (data.confPlannedDischargeDate)
              configuredate = data.confPlannedDischargeDate
            //let date = this.Datepipe.transform(event,'yyyy/MM/dd');
            let dosDate = new Date(event)
            let changeDate = dosDate.setDate(dosDate.getDate() + parseInt(configuredate))
            try {
              self.carePath.plannedDischargeDate = new Date(changeDate);
            } catch (Exception) { }

            //self.carePath.plannedAdmissionDate = new Date(self.carePath.plannedDischargeDate)

            if ((!self.carePath.plannedAdmissionDate)) {

              self.ModelRef41 = self.modalService.show(template15, { class: 'modal-sm', backdrop: 'static', keyboard: false })
              this.movable()
              if (self.carePath.plannedDischargeId) {
                if (self.carePath.plannedAdmissionDate) {
                  if (!self.carePath.dos) {
                    this.tempdate = self.carePath.plannedAdmissionDate
                    try {
                      self.carePath.plannedAdmissionDate = new Date()
                    } catch (Exception) { }
                  }
                } else {
                  try {
                    self.carePath.plannedAdmissionDate = new Date(self.carePath.plannedDischargeDate)
                  } catch (Exception) { }
                }

                /* self.checkempty11(self.carePath.plannedAdmissionDate);
                self.checkempty3(self.carePath.plannedDischargeDate); */
                /* self.carePath.plannedAdmissionDate = new Date(self.carePath.plannedDischargeDate)
                self.carePath.plannedDischargeId = ''
                self.carePath.plannedDischargeHospitalId = ''
                self.carePath.actualDischargeDate = ''
                self.carePath.actualAdmissionDate = ''
                self.carePath.actualDischargeId = ''
                self.carePath.actualDischargeHospitalId = ''
                self.carePath.dischargeContact = ''
                self.carePath.dischargePhone = '' */
              } else {
                if (!self.carePath.plannedAdmissionDate) {
                  try {
                    self.carePath.plannedAdmissionDate = new Date(self.carePath.plannedDischargeDate)
                  } catch (Exception) { }

                }
              }
            }

          })

      }
    }

  }

  onTopDOSDateChange() {
    for (var item of this.PACEventsData) {
      if (item.hospitalStay) {
        item.anonymousAdmissionDate = this.carePath.dos;

        let DosDate = this.changeFormatToDate(this.carePath.dos);
        item.anonymousSnfDischargeDatemindate = this.changeToDate(DosDate);

        if (item.trackActualVisible) {
          item.anonymousSnfDischargeDatemindate = this.changeToDate(DosDate);
          // item.anonymousSnfDischarge = ""
          // item.anonymousSnfDischargeDateFm = ""
          // item.trackActualVisible = false
          // item.status = "InProgress"
          // item.pacFinished = false
        }

        if (!item.pacFinished) {
          item.anonymousSnfDischargeDatemaxdate = null;
          var differDate = this.getPlannedDayInterval(-1);

          var differrencePlannedDate = this.addAdditionalDate(item.anonymousAdmissionDate, differDate)
          item.anonymousSnfDischargeDate = new Date(differrencePlannedDate);


          /*** New Date Start Here** */
          if (this.PACEventsData.length >= 2) {
            this.PACEventsData[1].anonymousAdmissionDate = new Date(differrencePlannedDate);
            this.PACEventsData[1].plannedDdCpDetails.plannedAdmissionDate = new Date(differrencePlannedDate);
          }


          item.plannedDdCpDetails.plannedSnfDischargeDate = differrencePlannedDate;
          item.plannedDdCpDetails.plannedAdmissionDate = item.anonymousAdmissionDate;
        }



      }
    }

  }
  diffdate: Date;
  addAdditionalDate(StratDate, addDateVal) {
    if (StratDate == "")
      return "";
    var date = this.changeFormatToDate(StratDate)
    this.diffdate = new Date(new Date(date).setHours(0, 0, 0, 0));
    this.diffdate.setDate(this.diffdate.getDate() + Number(addDateVal));
    return this.diffdate;
  }
  changeStringFormat2(dateString) {
    var dStartDate
    var changedFormat

    var date: any = new Date(dateString)
    if (date != '' && date != null && date != 'Invalid Date') {
      changedFormat = this.datepipe.transform(dateString, 'yyyy-MM-dd');
    } else if (date == 'Invalid Date' && dateString != 'Invalid Date' && dateString != undefined) {
      if (this.currentUser.item.language == 'en_uk') {
        var splitDate1 = dateString.split('/');
        var day1 = splitDate1[0];
        var month1 = splitDate1[1];
        var year1 = splitDate1[2];
        dStartDate = month1 + "/" + day1 + "/" + year1;
      }
      changedFormat = this.datepipe.transform(dStartDate, 'yyyy-MM-dd');
    }
    return changedFormat
  }
  checkplannedDisabled(event) {
    let self = this;
    let dos = new Date(event);
    let today = new Date();
    var timeDiff = Math.abs(dos.getTime() - today.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    if (diffDays == -1) {
      self.planneddisabled = true;
    } else {
      self.planneddisabled = false;
    }
  }
  onDOSChangePacEventValidate() {

    var startDate;
    if (this.getAppliedDischargeDate() == "")
      startDate = this.getAppliedPlannedDischargeDate();
    else
      startDate = this.getAppliedDischargeDate();

    /** Apply Dicharge Date */
    for (var item of this.PACEventsData) {
      if (!item.hospitalStay) {
        var admissionDate = this.findPastorFutureDate(this.changeFormatToDate(startDate), this.changeFormatToDate(item.anonymousAdmissionDate));
        var anoSnfDischargeDate = this.findPastorFutureDate(this.changeFormatToDate(startDate), this.changeFormatToDate(item.anonymousSnfDischargeDate));
        /* var plannedAdmissionDate = this.findPastorFutureDate(startDate,item.plannedDdCpDetails.plannedAdmissionDate);
        var plannedSnfDischargeDate = this.findPastorFutureDate(startDate,item.plannedDdCpDetails.plannedSnfDischargeDate); */

        if (admissionDate)
          item.anonymousstartdateRedAlert = true;
        else
          item.anonymousstartdateRedAlert = false;

        if (anoSnfDischargeDate)
          item.anonymousenddateRedAlert = true;
        else
          item.anonymousenddateRedAlert = false;


        /* if(plannedAdmissionDate)
          item.plannedDdCpDetails.plannedstartdateRedAlert =true;
        else
          item.plannedDdCpDetails.plannedstartdateRedAlert =false;

        if(plannedSnfDischargeDate)
          item.plannedDdCpDetails.plannedenddateRedAlert =true;
        else
        item.plannedDdCpDetails.plannedenddateRedAlert =false;   */
      }
    }
  }
  getAppliedDischargeDate() {
    for (var item of this.PACEventsData) {
      if (item.hospitalStay && item.trackActualVisible && item.pacFinished)
        return item.anonymousSnfDischargeDate;
    }
    return "";
  }
  getAppliedPlannedDischargeDate() {
    for (var item of this.PACEventsData) {
      if (item.hospitalStay)
        return item.plannedDdCpDetails.plannedSnfDischargeDate;
    }
    return "";
  }
  findPastorFutureDate(dos, argDate) {
    argDate = new Date(argDate);
    dos = new Date(dos);
    ////console.log('argDate'+argDate)
    ////console.log('dos'+dos)
    if (argDate < dos)
      return true;

    return false;
  }
  changeStringFormatToDate(dateString) {

    var changedFormat;
    try {
      changedFormat = this.datepipe.transform(dateString, 'MM/dd/yyyy');
    } catch (Exception) { }
    return changedFormat;
  }
  changeFormatToDate(dateString) {
    var changedFormat;
    if (this.currentUser.item.language == 'en_uk' && (typeof dateString == 'string' || dateString instanceof String)) {
      var splitDate1 = dateString.split('/');
      if (splitDate1.length > 1) {
        var day1 = splitDate1[0];
        var month1 = splitDate1[1];
        var year1 = splitDate1[2];
        changedFormat = month1 + "/" + day1 + "/" + year1;
        return changedFormat
      } else {
        var date: any = dateString
        return new Date(date)
      }
    } else {
      return new Date(dateString)
    }
  }

  changeToDate(dateValue) {
    return new Date(dateValue);
  }
  //Cancel DOS
  //Cancel Plan
  cancelScheduleObj: any;
  tempdate: any;
  cancelSchedule() {
    this.enablepatient = false
    this.patientservice.cancelSurgery(this.patid.patientSWFId,
      this.currentUser.item.userAccountId).subscribe(
        data => {
          this.modalRefcanSch.hide();
          this.cancelScheduleObj = data;

          this.enablepatient = true
          if (this.cancelScheduleObj.status == "true") {
            this.userService.logAudit('cancelSurgery', 0).subscribe(data => { })
            this.tempdate = '';
            //this.initFunction(mytodostatus);
            this.DOSChangeDate = "";
            this.saveBtnEnable = true;
            this.createPACEventbtn = true;
            this.reset('')
            this.toast.success(this.cancelScheduleObj.message, '', { timeOut: this.timealert });
            // this.SetDosStatus()
          } else
            this.toast.error(this.cancelScheduleObj.message, '', { timeOut: this.timealert })
        })
  }
  /** Cancel and reschedule start here */

  openCancel(template: TemplateRef<any>) {
    this.modalRefcanSch = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
    this.movable()
    this.enablepatient = true
  }


  hide41(autoAdjust) {
    let self = this;
    if (this.tempdate) {
      self.carePath.plannedAdmissionDate = new Date(this.tempdate);
    }
    self.ModelRef41.hide();
    if (this.textTemplate15) {
      this.reset('')

    }
    else {
      this.preSavePACKEvent(autoAdjust)
    }

  }


  //Presave PAC
  autoadjustTemplate: any;
  tempPacEventData: any;
  assessments: any = [];
  preSavePACKEvent(autoadjust) {
    if (this.textTemplate15) {
      this.reset('')
    }
    // for(var item of this.PACEventsData)
    // {
    //   item.anonymousSnfDischargeDate = new Date(item.anonymousSnfDischargeDate)
    //   if(item.pacFinished && this.carePath.dos.setHours(0,0,0,0) > item.anonymousSnfDischargeDate.setHours(0,0,0,0) && item.hospitalStay){
    //     this.createPACEventbtn = true;
    //   }
    // }
    // if(this.createPACEventbtn){
    //   this.PACEventsData = []
    // }
    if (this.PACEventsData.length == 0) {
      /*  setTimeout(() => { */

      this.dosChangeAPIService();

      /* },1000); */

    } else {
      this.autoadjustTemplate = autoadjust;
      this.tempPacEventData = JSON.parse(JSON.stringify(this.PACEventsData));
      var postEventDataTem = this.saveResultProcessing(this.tempPacEventData);
      let postEventData = this.assessments;
      postEventData[0]['dbCpDetailsList'] = postEventDataTem;
      postEventData[0]['dos'] = this.getDOSDate();
      postEventData[0]['hospitalStayStatus'] = this.getIsHosStayPlanORActu();
      postEventData[0]['pswActualDischargeDate'] = this.getDischargeDate();
      postEventData[0]['superClientId'] = window.localStorage['superClientId'] ? window.localStorage['superClientId'] : 0;
      var futuredate
      for (var itractionObj of this.PACEventsData) {
        if (!this.checkFutureDate(itractionObj)) {
          futuredate = true
          break;
        }
        else {
          futuredate = false
        }
      }
      if (!futuredate)
        this.saveAPIService(postEventData, "preSave");
      // this.hide41("")  //Test
      else {
        this.toast.error(this.userService.translateText('hospital_portal.disp_messages.cannot_process_with_future_date.error'), '', {
          timeOut: this.timealert
        })

        return "";
      }
    }
  }


  getAssement() {
    this.patientservice.getCarePlanAssessments(this.params.patientSWFId)
      .subscribe(data => {
        if (Array.isArray(data) && data.length) {
          this.assessments = data
        }
      })
  }



  isNonOp: boolean = false;
  dosChangeAPIService() {
    this.isNonOp = true;
    this.tempPacEventData = JSON.parse(JSON.stringify(this.PACEventsData));
    var postEventDataTem = this.saveResultProcessing(this.tempPacEventData);
    let postEventData = this.assessments;
    postEventData[0]['dbCpDetailsList'] = postEventDataTem;
    postEventData[0]['superClientId'] = window.localStorage['superClientId'] ? window.localStorage['superClientId'] : 0;
    this.saveAPIService(postEventData, "normal");
  }


  saveResultProcessing(postEventData) {

    //alert(JSON.stringify(postEventData));

    for (var i = 0; i < postEventData.length; i++) {
      var obj = postEventData[i];

      if (i == 0 || obj.status == "InProgress") {

        obj.plannedDdCpDetails.plannedDischargeDate = this.changeStringFormat2(obj.plannedDdCpDetails.plannedAdmissionDate);

        if (obj.hospitalStay)
          obj.pswActualDischargeDate = obj.anonymousSnfDischargeDate;

      }

      if (obj.anonymousAdmissionDate != "") {
        obj.anonymousAdmissionDate = this.changeStringFormat2(obj.anonymousAdmissionDate);
      }

      if (obj.anonymousSnfDischargeDate != "") {
        obj.anonymousSnfDischargeDate = this.changeStringFormat2(obj.anonymousSnfDischargeDate);
      }

      if (obj.anonymousDischargeHospitalMasterId == -2)
        obj.anonymousDischargeHospitalMasterId = "";






      // alert(obj.anonymousOtherSelectedName)
      // alert(obj.plannedDdCpDetails.plannedOtherSelectedName)
      /*** If Not Other Clear all Other Values Here ***/
      this.clearOtherPropertyValues(obj);
      if (obj.anonymousDischargeId == -2)
        obj.anonymousDischargeId = 5;


      // alert(obj.anonymousOtherSelectedName)
      // alert(obj.plannedDdCpDetails.plannedOtherSelectedName)

      /* if(obj.trackActualEmptyEndDate)
          obj.anonymousSnfDischargeDate = ""; */

      if (obj.plannedDdCpDetails.plannedAdmissionDate != "")
        obj.plannedDdCpDetails.plannedAdmissionDate = this.changeStringFormat2(obj.plannedDdCpDetails.plannedAdmissionDate);

      if (obj.plannedDdCpDetails.plannedSnfDischargeDate != "")
        obj.plannedDdCpDetails.plannedSnfDischargeDate = this.changeStringFormat2(obj.plannedDdCpDetails.plannedSnfDischargeDate);

      if (obj.dos != "")
        obj.dos = this.changeStringFormat2(obj.dos);

      if (obj.anonymousAdmissionDate != "")
        obj.anonymousAdmissionDate = this.changeStringFormat2(obj.anonymousAdmissionDate);

      if (obj.plannedDdCpDetails.plannedAdmissionDate != "")
        obj.plannedDdCpDetails.plannedAdmissionDate = this.changeStringFormat2(obj.plannedDdCpDetails.plannedAdmissionDate);


      obj.anonymousDischargeDate = !obj.anonymousDischargeDate ? obj.anonymousDischargeDate
        : this.changeStringFormat2(obj.anonymousDischargeDate);
      if (obj.plannedDdCpDetails.plannedDischargeDate != "" && !obj.hospitalStay) {
        obj.plannedDdCpDetails.plannedDischargeDate = !obj.plannedDdCpDetails.plannedDischargeDate ? obj.plannedDdCpDetails.plannedDischargeDate
          : this.changeStringFormat2(obj.plannedDdCpDetails.plannedDischargeDate);
      }
      obj.pswActualDischargeDate = !obj.pswActualDischargeDate ? obj.pswActualDischargeDate
        : this.changeStringFormat2(obj.pswActualDischargeDate);

      if (obj.anonymousDischargeId == 6) {

        if (obj.anonymousSnfDischargeDate == "" || obj.anonymousSnfDischargeDate == null)
          obj.pacFinished = false;

        obj.plannedDdCpDetails.plannedDdCpDetails = ""
        obj.plannedDdCpDetails.plannedDischargeDate = "";
        obj.plannedDdCpDetails.plannedSnfDischargeDate = "";
        obj.plannedDdCpDetails.plannedDischargeId = 0;
        obj.plannedDdCpDetails.plannedDischargeHospitalMasterId = 0;
        obj.plannedDdCpDetails.plannedLos = "";
        obj.plannedDdCpDetails.plannedAdmissionDate = "";
        obj.plannedDdCpDetails.plannedVisit = "";
        obj.plannedDdCpDetails.plannedOtherSelectedName = "";
        obj.plannedDdCpDetails.plannedDischargeTypeForOther = "";
      }

    }

    return postEventData;

  }

  clearOtherPropertyValues(item) {
    if (item.anonymousDischargeId != -2) {
      //alert("Call");
      item.anonymousOtherSelectedName = "";
      item.anonymousOtherFreeText = "";
      item.anonymousOtherPacContact = "";
      item.anonymousHospitalOtherPacMapId = 0;
      item.anonymousOtherPacMasterId = 0;
      item.anonymousOtherPacPhone = "";
      item.anonymousOtherPacTeleCode = "";
      item.anonymousOtherPacTeleCountryCode = "";
      item.anonymousOtherPacTurnedOn = true;

      item.plannedDdCpDetails.plannedOtherSelectedName = "";
      item.plannedDdCpDetails.plannedOtherFreeText = "";
      item.plannedDdCpDetails.plannedOtherPacContact = "";
      item.plannedDdCpDetails.plannedOtherPacPhone = "";
      item.plannedDdCpDetails.plannedOtherPacTeleCode = "";
      item.plannedDdCpDetails.plannedOtherPacTeleCountryCode = "";
      item.plannedDdCpDetails.plannedHospitalOtherPacMapId = 0;
      item.plannedDdCpDetails.plannedOtherPacMasterId = 0;
      item.plannedDdCpDetails.plannedOtherPacTurnedOn = true;

    }
  }

  getDOSDate() {
    for (var item of this.PACEventsData) {
      if (item.hospitalStay) {
        var dateStr = this.changeStringFormat2(this.carePath.dos);
        return dateStr;
      }
    }
    return "";
  }

  getIsHosStayPlanORActu() {
    for (var item of this.PACEventsData) {
      if (item.hospitalStay && item.status == "InProgress")
        return "Current";
      else if (item.hospitalStay && item.status == "Completed")
        return "Completed";
    }
  }


  getDischargeDate() {
    for (var item of this.PACEventsData) {
      if (item.hospitalStay && item.pacFinished) {
        var dateStr = this.changeStringFormat2(item.anonymousSnfDischargeDate);
        return dateStr;
      }
    }
    return "";
  }

  checkFutureDate(item) {
    // for(var item of this.PACEventsData)
    // {
    if (item.anonymousSnfDischargeDate && item.anonymousSnfDischargeDatemaxdate) {
      if (new Date(item.anonymousSnfDischargeDate) > item.anonymousSnfDischargeDatemaxdate) {
        item.anonymousSnfDischargeDate = "";
        item.anonymousenddateRedAlert = true;
        // if(item.backupStauts=='InProgress'){
        //   this.PACEventsData.forEach(element => {
        //     if(element.status=='InProgress'){
        //       element.status='UpComing'
        //     }
        //   });
        // }

        // item.status = item.backupStauts;
        // // if(item.backupStauts=='InProgress')
        // item.pacFinished = false
        // item.trackActualVisible = false;
        // item.trackActualEmptyEndDate =false;
        return false;
      }
    }
    if (item.anonymousAdmissionDate && item.anonymousAdmissionDatemaxdate) {
      if (new Date(item.anonymousAdmissionDate) > item.anonymousAdmissionDatemaxdate) {
        item.anonymousAdmissionDate = "";
        item.anonymousstartdateRedAlert = true;
        return false;
      }
    }
    // }
    return true;
  }

  saveAPIService(data, type) {
    let dos = this.datepipe.transform(this.carePath.dos, 'yyyy-MM-dd')
    if (this.onPacEventValidateWithDOS()) {
      if (this.onPacEventHospitalStayValidationDOS()) {
        if (this.checkStarDateEndDate()) {

          this.showloader = true

          this.patientservice.saveCarePlan(this.params.patientSWFId, data, type, this.DOSChangeDate, this.selectedUserId)
            .subscribe(data => {
              this.showloader = false;
              ////console.log("Responsedata", data)

              this.PACEventsData = data;

              this.toast.success(this.userService.translateText('hospital_portal.disp_messages.dos_updated.success'), '', {
                timeOut: this.timealert
              })
              this.userService.logAudit('DOSUpdate', 0).subscribe(data => { })
              this.reset('')
            })


        } else {
          this.nav.navigate([`/care/patientsummary/${dos}/true`]);
        }

      }
      else {
        this.nav.navigate([`/care/patientsummary/${dos}/true`]);
      }
    }
    else {
      this.nav.navigate([`/care/patientsummary/${dos}/true`]);
    }




  }

  //Check Start&End Date
  checkStarDateEndDate() {
    for (var item of this.PACEventsData) {
      if (item.anonymousAdmissionDate && item.anonymousSnfDischargeDate) {
        var checkStarDateandEndDate = this.findPastorFutureDate(this.changeFormatToDate(item.anonymousAdmissionDate), this.changeFormatToDate(item.anonymousSnfDischargeDate))
        if (checkStarDateandEndDate) {
          item.anonymousstartdateRedAlert = true;
          item.anonymousenddateRedAlert = true;
          return false;
        }
      }
    }
    return true;
  }
  onPacEventValidateWithDOS() {
    /** Apply Dicharge Date **/

    var startDate;
    if (this.getAppliedDischargeDate() == "")
      startDate = this.getAppliedPlannedDischargeDate();
    else
      startDate = this.getAppliedDischargeDate();

    for (var item of this.PACEventsData) {

      if (!item.hospitalStay && item.anonymousDischargeId) {
        var admissionDate = this.findPastorFutureDate(this.changeFormatToDate(startDate), this.changeFormatToDate(item.anonymousAdmissionDate));
        var anoSnfDischargeDate = this.findPastorFutureDate(this.changeFormatToDate(startDate), this.changeFormatToDate(item.anonymousSnfDischargeDate));

        /* var plannedAdmissionDate = this.findPastorFutureDate(startDate,item.plannedDdCpDetails.plannedAdmissionDate);
        var plannedSnfDischargeDate = this.findPastorFutureDate(startDate,item.plannedDdCpDetails.plannedSnfDischargeDate); */
        /* ||  plannedAdmissionDate || plannedSnfDischargeDate */


        if (admissionDate || anoSnfDischargeDate) {
          this.onDOSChangePacEventValidate();
          return false;
        }
      }


    }

    this.onDOSChangePacEventValidate();
    return true;
  }



  onPacEventHospitalStayValidationDOS() {

    for (var item of this.PACEventsData) {

      if (item.hospitalStay) {
        var admissionDate = this.findPastorFutureDate(this.changeFormatToDate(item.anonymousAdmissionDate), this.changeFormatToDate(item.anonymousSnfDischargeDate));

        // var anoSnfDischargeDate = this.findPastorFutureDate(startDate,item.anonymousSnfDischargeDate);

        /* var plannedAdmissionDate = this.findPastorFutureDate(startDate,item.plannedDdCpDetails.plannedAdmissionDate);
        var plannedSnfDischargeDate = this.findPastorFutureDate(startDate,item.plannedDdCpDetails.plannedSnfDischargeDate); */
        /* ||  plannedAdmissionDate || plannedSnfDischargeDate */

        if (admissionDate) {
          item.anonymousstartdateRedAlert = true;
          item.anonymousenddateRedAlert = true;
          return false;
        }
      }


    }
    return true;
  }
  reset(ed, refreshPage = false) {
    if (ed) {
      ed.resetForm();
      this.checkFormDisable = false;
    }
    let url = window.location.href;
    let patDetails = {
      'patientId': this.params.patientId,
      'patientSWFId': this.params.patientSWFId,
      'patstatus': this.params.patstatus,
      'status': this.params.status
    }
    window.localStorage['patDetails'] = btoa(JSON.stringify(patDetails))
    if (!refreshPage)          //To prevent Page refresh
      if (url.includes('/patientdetails'))
        this.nav.navigate([`care/patientdetail`]);
      else
        this.nav.navigate([`care/patientdetails`]);
  }

  hspId: any;
  siteToolTip(id, cond) {
    let returnData: any = "";
    let checkDate;
    if (cond == 1 && this.hospitalList) {
      checkDate = this.hospitalList.filter(it =>
        it.hospitalPracticeid == id)
    }
    else if (cond == 2 && this.facility) {
      checkDate = this.facility.filter(it => it.hspPracticeId == id
        || it.hospitalPracticeid == id)
    }
    if (checkDate && checkDate.length != 0) {
      returnData = checkDate[0].name;
      this.hspId = checkDate[0].hospitalId
    }


    return returnData;
  }

  //Change Surgeon based on Site of Service
  selecthosp: any = [];
  changeSurgoen(event, onchange) {
    let self = this;
    let temArray, temArray1 = []
    temArray = _.filter(self.surgeonList, (n) => {
      return n.surgeonId == event
    })
    if (this.hospitalList) {
      temArray1 = _.filter(this.hospitalList, (n) => {
        return (n.name.match('Unknown') || n.name.match('Other'))
      })
      temArray1 = temArray1.map(function (el) { return el.hospitalId; });
    }
    self.selecthosp = JSON.parse(temArray[0].hospitalList)
    if (temArray1.length > 0 && self.selecthosp.length > 0) {
      self.selecthosp = self.selecthosp.concat(temArray1)
    }
    if (onchange && self.user.surgeonId != this.patientdetail.surgeon && self.selecthosp.length != 0) {
      this.patientdetail.site = ''
      this.shospital4 = true
    }
    else if (environment.OpBodyPart.search(this.patientdetail.procedure) == -1 && this.hospitalList && onchange) {

      let index = _.findIndex(self.hospitalList, (o: any): any => {
        return o.hospitalPracticeid == this.patientdetail.site
      })
      if (index != -1 && self.hospitalList[index].admissionId == 2) {
        this.patientdetail.site = ''
        this.shospital4 = true
      }
      this.hospitalList = _.filter(this.hospitalList, (o: any): any => {
        return o.admissionId != 2
      })
      //console.log(JSON.stringify(this.hospitalList))
    } else {
      this.patientdetail.site = self.user.hospitalPracticeid
      this.shospital4 = false
    }
    if (this.patientinfo.commercialPatient) {
      this.fcn(this.payorId, event)
    }
  }

  rejectSpecialCharacters(stringValue: any, formControlName: string) {

    const specialCharsSet = new Set("[!@#$%^&*()_~+-=\\{};':|,.<>\/?]+/`");
    for (let letter of this.patientdetail[formControlName]) {
      if (specialCharsSet.has(letter) || letter == '"') {
        this.patientdetail[formControlName] = this.patientdetail[formControlName].replaceAll(letter, '')
      }
    }
  }


  //Alternate Phone Number
  viewalterno(phoneOthervalue) {
    if (!phoneOthervalue) {
      this.phoneOthervalue = true
      this.patientdetail.otherPhoneType = 1
      this.changeAlterNo()
    }
  }
  changeAlterNo() {
    if (this.currentUser.item.language != 'en_uk') {
      this.patientdetail.codeOther = '+1,USA'
    } else if (this.currentUser.item.language == 'en_uk') {
      this.patientdetail.codeOther = '+44,UK'
    }
    if (this.currentUser.item.clientTeleCode) {
      this.patientdetail.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
    }
    this.patientdetail.phoneOther = ''
  }


  getClientType() {
    if (this.clienttype && (this.clienttype.search("CJR") != -1 || this.clienttype.search("PRO_ONLY") != -1))
      return 'CJR'
    else if (this.clienttype && (this.clienttype.search("MAKO") != -1 || this.clienttype.search("NON_GROUP") != -1))
      return 'MAKO'
    else
      return false
  }
  duplicateshow
  yesToShowUser(status) {
    this.duplicateshow = !status
    this.modalRef1.hide();
    this.modalRef1 = undefined;
    if (status) {

      if (this.userinfo.DOB)
        this.patientdetail.dob = new Date(this.userinfo.DOB);
      if (this.userinfo.imagePath && this.userinfo.imagePath.search("default_") == -1) {
        if (this.currentUser.item) {
          if (this.currentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;
        }
        this.patientUrl = this.imageURL + this.userinfo.imagePath;
      }
      this.patientdetail.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
      this.patientdetail.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
      if (this.userinfo.teleCode)
        this.patientdetail.code = this.userinfo.teleCode + ',' + this.userinfo.teleCountryCode;
      if (this.userinfo.teleCodeOther)
        this.patientdetail.codeOther = this.userinfo.teleCodeOther + ',' + this.userinfo.teleCountryCodeOther;
      if (this.userinfo.email)
        this.temMail = this.userinfo.email
      if (this.userinfo.phone)
        this.tempphone = this.userinfo.phone
      this.patientdetail.firstName = this.userinfo.firstName
      this.patientdetail.lastName = this.userinfo.lastName
      this.patientdetail.email = this.userinfo.email ? this.userinfo.email : ''
      this.patientdetail.phone = this.userinfo.phone ? this.userinfo.phone : ''
      this.patientdetail.phoneOther = this.userinfo.phoneOther ? this.userinfo.phoneOther : ''
      this.patientdetail.otherPhoneType = this.userinfo.otherPhoneType ? this.userinfo.otherPhoneType : 1
      this.patientdetail.weight = this.userinfo.Weight ? this.userinfo.Weight : 0
      this.patientdetail.height = this.userinfo.Height ? this.userinfo.Height : 0
      this.patientdetail.inch = this.userinfo.Inch ? this.userinfo.Inch : 0
      this.patientdetail.bmi = this.userinfo.BMI ? this.userinfo.BMI : 0
      this.patientdetail.mrnNo = this.userinfo.MRN ? this.userinfo.MRN : ''
      this.patientdetail.hic = this.userinfo.HIC ? this.userinfo.HIC : ''
      this.patientdetail.ssn = this.userinfo.SSN ? this.userinfo.SSN : ''
    } else {
      this.patientdetail.email = ''
      this.patientdetail.phone = ''
      this.checkEmailClear = false
      this.checkPhoneClear = false
      if (this.currentUser.item.language != 'en_uk') {
        this.patientdetail.code = '+1,USA'
      } else if (this.currentUser.item.language == 'en_uk') {
        this.patientdetail.code = '+44,UK'
      }
    }
  }
}
